var bodyScrollLockOptions = {
    reserveScrollBarGap: false,
};

window.lazySizesConfig = window.lazySizesConfig || {};
lazySizesConfig.loadMode = 1; // Load elements on view or nearby
lazySizesConfig.expand = 10; // Expand the lazy-loading area by 10px
lazySizesConfig.expFactor = 1.5; // Increase expand amount by 1.5 times
lazySizesConfig.throttleDelay = 300; // Delay in milliseconds before checking the scroll position

var Shopify = Shopify || {};
// ---------------------------------------------------------------------------
// Money format handler
// ---------------------------------------------------------------------------
Shopify.money_format = "${{amount}}";
Shopify.formatMoney = function (cents, format) {
    if (typeof cents == "string") {
        cents = cents.replace(".", "");
    }
    var value = "";
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = format || this.money_format;

    function defaultOption(opt, def) {
        return typeof opt == "undefined" ? def : opt;
    }

    function formatWithDelimiters(number, precision, thousands, decimal) {
        precision = defaultOption(precision, 2);
        thousands = defaultOption(thousands, ",");
        decimal = defaultOption(decimal, ".");

        if (isNaN(number) || number == null) {
            return 0;
        }

        number = (number / 100.0).toFixed(precision);

        var parts = number.split("."),
            dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands),
            cents = parts[1] ? decimal + parts[1] : "";

        return dollars + cents;
    }

    switch (formatString.match(placeholderRegex)[1]) {
        case "amount":
            value = formatWithDelimiters(cents, 2);
            break;
        case "amount_no_decimals":
            value = formatWithDelimiters(cents, 0);
            break;
        case "amount_with_comma_separator":
            value = formatWithDelimiters(cents, 2, ".", ",");
            break;
        case "amount_no_decimals_with_comma_separator":
            value = formatWithDelimiters(cents, 0, ".", ",");
            break;
    }

    return formatString.replace(placeholderRegex, value);
};

/**
 * DOM event delegator
 *
 * The delegator will listen
 * for events that bubble up
 * to the root node.
 *
 * @constructor
 * @param {Node|string} [root] The root node or a selector string matching the root node
 */
function Delegate(root) {
    /**
     * Maintain a map of listener
     * lists, keyed by event name.
     *
     * @type Object
     */
    this.listenerMap = [{}, {}];
    if (root) {
        this.root(root);
    }

    /** @type function() */
    this.handle = Delegate.prototype.handle.bind(this);

    // Cache of event listeners removed during an event cycle
    this._removedListeners = [];
}

/**
 * Start listening for events
 * on the provided DOM element
 *
 * @param  {Node|string} [root] The root node or a selector string matching the root node
 * @returns {Delegate} This method is chainable
 */
Delegate.prototype.root = function (root) {
    const listenerMap = this.listenerMap;
    let eventType;

    // Remove master event listeners
    if (this.rootElement) {
        for (eventType in listenerMap[1]) {
            if (listenerMap[1].hasOwnProperty(eventType)) {
                this.rootElement.removeEventListener(eventType, this.handle, true);
            }
        }
        for (eventType in listenerMap[0]) {
            if (listenerMap[0].hasOwnProperty(eventType)) {
                this.rootElement.removeEventListener(eventType, this.handle, false);
            }
        }
    }

    // If no root or root is not
    // a dom node, then remove internal
    // root reference and exit here
    if (!root || !root.addEventListener) {
        if (this.rootElement) {
            delete this.rootElement;
        }
        return this;
    }

    /**
     * The root node at which
     * listeners are attached.
     *
     * @type Node
     */
    this.rootElement = root;

    // Set up master event listeners
    for (eventType in listenerMap[1]) {
        if (listenerMap[1].hasOwnProperty(eventType)) {
            this.rootElement.addEventListener(eventType, this.handle, true);
        }
    }
    for (eventType in listenerMap[0]) {
        if (listenerMap[0].hasOwnProperty(eventType)) {
            this.rootElement.addEventListener(eventType, this.handle, false);
        }
    }

    return this;
};

/**
 * @param {string} eventType
 * @returns boolean
 */
Delegate.prototype.captureForType = function (eventType) {
    return (
        ["blur", "error", "focus", "load", "resize", "scroll"].indexOf(
            eventType
        ) !== -1
    );
};

/**
 * Attach a handler to one
 * event for all elements
 * that match the selector,
 * now or in the future
 *
 * The handler function receives
 * three arguments: the DOM event
 * object, the node that matched
 * the selector while the event
 * was bubbling and a reference
 * to itself. Within the handler,
 * 'this' is equal to the second
 * argument.
 *
 * The node that actually received
 * the event can be accessed via
 * 'event.target'.
 *
 * @param {string} eventType Listen for these events
 * @param {string|undefined} selector Only handle events on elements matching this selector, if undefined match root element
 * @param {function()} handler Handler function - event data passed here will be in event.data
 * @param {boolean} [useCapture] see 'useCapture' in <https://developer.mozilla.org/en-US/docs/Web/API/EventTarget/addEventListener>
 * @returns {Delegate} This method is chainable
 */
Delegate.prototype.on = function (eventType, selector, handler, useCapture) {
    let root;
    let listenerMap;
    let matcher;
    let matcherParam;

    if (!eventType) {
        throw new TypeError("Invalid event type: " + eventType);
    }

    // handler can be passed as
    // the second or third argument
    if (typeof selector === "function") {
        useCapture = handler;
        handler = selector;
        selector = null;
    }

    // Fallback to sensible defaults
    // if useCapture not set
    if (useCapture === undefined) {
        useCapture = this.captureForType(eventType);
    }

    if (typeof handler !== "function") {
        throw new TypeError("Handler must be a type of Function");
    }

    root = this.rootElement;
    listenerMap = this.listenerMap[useCapture ? 1 : 0];

    // Add master handler for type if not created yet
    if (!listenerMap[eventType]) {
        if (root) {
            root.addEventListener(eventType, this.handle, useCapture);
        }
        listenerMap[eventType] = [];
    }

    if (!selector) {
        matcherParam = null;

        // COMPLEX - matchesRoot needs to have access to
        // this.rootElement, so bind the function to this.
        matcher = matchesRoot.bind(this);

        // Compile a matcher for the given selector
    } else if (/^[a-z]+$/i.test(selector)) {
        matcherParam = selector;
        matcher = matchesTag;
    } else if (/^#[a-z0-9\-_]+$/i.test(selector)) {
        matcherParam = selector.slice(1);
        matcher = matchesId;
    } else {
        matcherParam = selector;
        matcher = Element.prototype.matches;
    }

    // Add to the list of listeners
    listenerMap[eventType].push({
        selector: selector,
        handler: handler,
        matcher: matcher,
        matcherParam: matcherParam,
    });

    return this;
};

/**
 * Remove an event handler
 * for elements that match
 * the selector, forever
 *
 * @param {string} [eventType] Remove handlers for events matching this type, considering the other parameters
 * @param {string} [selector] If this parameter is omitted, only handlers which match the other two will be removed
 * @param {function()} [handler] If this parameter is omitted, only handlers which match the previous two will be removed
 * @returns {Delegate} This method is chainable
 */
Delegate.prototype.off = function (eventType, selector, handler, useCapture) {
    let i;
    let listener;
    let listenerMap;
    let listenerList;
    let singleEventType;

    // Handler can be passed as
    // the second or third argument
    if (typeof selector === "function") {
        useCapture = handler;
        handler = selector;
        selector = null;
    }

    // If useCapture not set, remove
    // all event listeners
    if (useCapture === undefined) {
        this.off(eventType, selector, handler, true);
        this.off(eventType, selector, handler, false);
        return this;
    }

    listenerMap = this.listenerMap[useCapture ? 1 : 0];
    if (!eventType) {
        for (singleEventType in listenerMap) {
            if (listenerMap.hasOwnProperty(singleEventType)) {
                this.off(singleEventType, selector, handler);
            }
        }

        return this;
    }

    listenerList = listenerMap[eventType];
    if (!listenerList || !listenerList.length) {
        return this;
    }

    // Remove only parameter matches
    // if specified
    for (i = listenerList.length - 1; i >= 0; i--) {
        listener = listenerList[i];

        if (
            (!selector || selector === listener.selector) &&
            (!handler || handler === listener.handler)
        ) {
            this._removedListeners.push(listener);
            listenerList.splice(i, 1);
        }
    }

    // All listeners removed
    if (!listenerList.length) {
        delete listenerMap[eventType];

        // Remove the main handler
        if (this.rootElement) {
            this.rootElement.removeEventListener(eventType, this.handle, useCapture);
        }
    }

    return this;
};

/**
 * Handle an arbitrary event.
 *
 * @param {Event} event
 */
Delegate.prototype.handle = function (event) {
    let i;
    let l;
    const type = event.type;
    let root;
    let phase;
    let listener;
    let returned;
    let listenerList = [];
    let target;
    const eventIgnore = "ftLabsDelegateIgnore";

    if (event[eventIgnore] === true) {
        return;
    }

    target = event.target;

    // Hardcode value of Node.TEXT_NODE
    // as not defined in IE8
    if (target.nodeType === 3) {
        target = target.parentNode;
    }

    // Handle SVG <use> elements in IE
    if (target.correspondingUseElement) {
        target = target.correspondingUseElement;
    }

    root = this.rootElement;

    phase = event.eventPhase || (event.target !== event.currentTarget ? 3 : 2);

    // eslint-disable-next-line default-case
    switch (phase) {
        case 1: //Event.CAPTURING_PHASE:
            listenerList = this.listenerMap[1][type];
            break;
        case 2: //Event.AT_TARGET:
            if (this.listenerMap[0] && this.listenerMap[0][type]) {
                listenerList = listenerList.concat(this.listenerMap[0][type]);
            }
            if (this.listenerMap[1] && this.listenerMap[1][type]) {
                listenerList = listenerList.concat(this.listenerMap[1][type]);
            }
            break;
        case 3: //Event.BUBBLING_PHASE:
            listenerList = this.listenerMap[0][type];
            break;
    }

    let toFire = [];

    // Need to continuously check
    // that the specific list is
    // still populated in case one
    // of the callbacks actually
    // causes the list to be destroyed.
    l = listenerList.length;
    while (target && l) {
        for (i = 0; i < l; i++) {
            listener = listenerList[i];

            // Bail from this loop if
            // the length changed and
            // no more listeners are
            // defined between i and l.
            if (!listener) {
                break;
            }

            if (
                target.tagName &&
                ["button", "input", "select", "textarea"].indexOf(
                    target.tagName.toLowerCase()
                ) > -1 &&
                target.hasAttribute("disabled")
            ) {
                // Remove things that have previously fired
                toFire = [];
            }
                // Check for match and fire
                // the event if there's one
                //
                // TODO:MCG:20120117: Need a way
                // to check if event#stopImmediatePropagation
            // was called. If so, break both loops.
            else if (listener.matcher.call(target, listener.matcherParam, target)) {
                toFire.push([event, target, listener]);
            }
        }

        // TODO:MCG:20120117: Need a way to
        // check if event#stopPropagation
        // was called. If so, break looping
        // through the DOM. Stop if the
        // delegation root has been reached
        if (target === root) {
            break;
        }

        l = listenerList.length;

        // Fall back to parentNode since SVG children have no parentElement in IE
        target = target.parentElement || target.parentNode;

        // Do not traverse up to document root when using parentNode, though
        if (target instanceof HTMLDocument) {
            break;
        }
    }

    let ret;

    for (i = 0; i < toFire.length; i++) {
        // Has it been removed during while the event function was fired
        if (this._removedListeners.indexOf(toFire[i][2]) > -1) {
            continue;
        }
        returned = this.fire.apply(this, toFire[i]);

        // Stop propagation to subsequent
        // callbacks if the callback returned
        // false
        if (returned === false) {
            toFire[i][0][eventIgnore] = true;
            toFire[i][0].preventDefault();
            ret = false;
            break;
        }
    }

    return ret;
};

/**
 * Fire a listener on a target.
 *
 * @param {Event} event
 * @param {Node} target
 * @param {Object} listener
 * @returns {boolean}
 */
Delegate.prototype.fire = function (event, target, listener) {
    return listener.handler.call(target, event, target);
};

/**
 * Check whether an element
 * matches a tag selector.
 *
 * Tags are NOT case-sensitive,
 * except in XML (and XML-based
 * languages such as XHTML).
 *
 * @param {string} tagName The tag name to test against
 * @param {Element} element The element to test with
 * @returns boolean
 */
function matchesTag(tagName, element) {
    return tagName.toLowerCase() === element.tagName.toLowerCase();
}

/**
 * Check whether an element
 * matches the root.
 *
 * @param {?String} selector In this case this is always passed through as null and not used
 * @param {Element} element The element to test with
 * @returns boolean
 */
function matchesRoot(selector, element) {
    if (this.rootElement === window) {
        return (
            // Match the outer document (dispatched from document)
            element === document ||
            // The <html> element (dispatched from document.body or document.documentElement)
            element === document.documentElement ||
            // Or the window itself (dispatched from window)
            element === window
        );
    }
    return this.rootElement === element;
}

/**
 * Check whether the ID of
 * the element in 'this'
 * matches the given ID.
 *
 * IDs are case-sensitive.
 *
 * @param {string} id The ID to test against
 * @param {Element} element The element to test with
 * @returns boolean
 */
function matchesId(id, element) {
    return id === element.id;
}

/**
 * Short hand for off()
 * and root(), ie both
 * with no parameters
 *
 * @return void
 */
Delegate.prototype.destroy = function () {
    this.off();
    this.root();
};

class Popup {
    constructor(element) {
        this.element = element;
        this.delegateElement = new Delegate(this.element);
        this.pageOverlayElement = document.querySelector(".pageOverlay");
        this.bindEvents();
    }

    bindEvents() {
        this.delegateElement.on(
            "click",
            '[data-action="open-modal"]',
            this.openModal.bind(this)
        );
        this.delegateElement.on(
            "click",
            '[data-action="close-modal"]',
            this.closeModal.bind(this)
        );
        document.addEventListener(
            "posted_successfully",
            this.openModalSpecial.bind(this)
        );

        this.onClickOutsideListener = this.closeModal.bind(this);
    }

    openModal() {
        event.preventDefault();
        event.stopPropagation();
        this.pageOverlayElement.classList.add("is-visible");
        this.activeModal = document.getElementById(
            event.target.getAttribute("aria-controls")
        );
        this.activeModal.setAttribute("aria-hidden", "false");
        this.activeModal.style.display = "block";
        this.pageOverlayElement.addEventListener(
            "click",
            this.onClickOutsideListener
        );
        var focus = this.element.querySelector("[data-scrollable]");

        setTimeout(() => {
            trapFocus(this.activeModal);
        }, 100);
        bodyScrollLock.disableBodyScroll(focus, bodyScrollLockOptions);
    }

    openModalSpecial() {
        event.preventDefault();
        event.stopPropagation();
        this.pageOverlayElement.classList.add("is-visible");
        this.activeModal = document.getElementById(event.detail.id);
        this.activeModal.setAttribute("aria-hidden", "false");
        var focus = this.element.querySelector("[data-scrollable]");
        this.pageOverlayElement.addEventListener(
            "click",
            this.onClickOutsideListener
        );
        bodyScrollLock.disableBodyScroll(focus, bodyScrollLockOptions);
        trapFocus(this.activeModal);
    }

    closeModal() {
        this.activeModal = document.body.querySelector(
            '.Popup[aria-hidden="false"]'
        );
        this.pageOverlayElement.classList.remove("is-visible");
        this.pageOverlayElement.removeEventListener(
            "click",
            this.onClickOutsideListener
        );
        this.activeModal.setAttribute("aria-hidden", "true");

        bodyScrollLock.clearAllBodyScrollLocks();
        this.activeModal.removeAttribute("style");
    }
}

class RevolutionImageZoom {
    constructor(element, slideshow) {
        this.element = element;
        this.slideshow = slideshow;
        this.delegateElement = new Delegate(this.element);
        this.delegateRoot = new Delegate(document.body);
        this.syncHeight();
        this.bindEvents();
    }

    syncHeight() {
        document.documentElement.style.setProperty(
            "--window-inner-height",
            `${window.innerHeight}px`
        );
    }

    bindEvents() {
        window.addEventListener("resize", this.syncHeight());
        this.delegateElement.on(
            "click",
            '[data-action="open-product-zoom"]',
            this.initPhotoSwipe.bind(this)
        );
        this.delegateElement.on(
            "click",
            ".ProductSliderCell--Zoom",
            this.initPhotoSwipeFromImageClick.bind(this)
        );
        this.delegateRoot.on(
            "pswpTap",
            ".pswp__button--close",
            this.photoswiperClose.bind(this)
        );
    }

    photoswiperClose() {
        this.photoSwipeInstance.close;
        if (/iPhone|iPad|iPod/i.test(window.navigator.userAgent)) {
            document.documentElement.classList.remove("pswp-open-in-ios");
        }
    }

    initPhotoSwipe() {
        var images = [],
            index = 0;
        if (this.slideshow) {
            this.slideshow.swiperElement.slides.forEach(function (item) {
                if (item.classList.contains("ProductSliderCell--Zoom")) {
                    if (item.querySelector("img")) {
                        images.push(item.querySelector("img"));
                    }
                }
            });
            var index_currentSlide = this.slideshow.swiperElement.realIndex;
            this.slideshow.swiperElement.slides[index_currentSlide]
                .querySelector(".ProductSlider--Element")
                .getAttribute("data-image-position");
        } else {
            images.push(document.querySelector(".ProductSlider--Image"));
        }

        this.createPhotoSwipeInstance(
            this.createPhotoSwipeItemsFromImages(images),
            parseInt(index)
        );
    }

    initPhotoSwipeFromImageClick(event, target) {
        if (new Responsive().matchesBreakpoint("pocket")) {
            return;
        }
        var images = [];

        new DomHelper().getSiblings(target, null, true).forEach(function (item) {
            if (
                item.classList.contains("ProductSliderCell--Zoom") &&
                item.querySelector("img")
            ) {
                images.push(item.querySelector("img"));
            }
        });
        this.createPhotoSwipeInstance(
            this.createPhotoSwipeItemsFromImages(images),
            parseInt(
                target
                    .querySelector(".ProductSlider--Element")
                    .getAttribute("data-image-position")
            )
        );
    }

    createPhotoSwipeItemsFromImages(images) {
        return images.map(function (image) {
            var maxWidth = parseInt(image.getAttribute("data-max-width")),
                maxHeight = parseInt(image.getAttribute("data-max-height")),
                maxDimension = new Responsive().matchesBreakpoint("phone")
                    ? 1200
                    : 2200,
                reduceFactor = 1.0;

            if (maxWidth >= maxHeight) {
                reduceFactor = Math.max(maxWidth / maxDimension, 1.0);
            } else {
                reduceFactor = Math.max(maxHeight / maxDimension, 1.0);
            }
            var requestedWidth = Math.floor(maxWidth / reduceFactor);
            var requestedHeight = Math.floor(maxHeight / reduceFactor);
            return {
                msrc: image.currentSrc || image.src,
                w: requestedWidth,
                h: requestedHeight,
                initialZoomLevel: 0.65,
                src: new RevolutionImage().getSizedImageUrl(
                    image.getAttribute("data-original-src"),
                    requestedWidth + "x" + requestedHeight
                ),
            };
        });
    }

    createPhotoSwipeInstance(items, selectedImageIndex) {
        var _this = this;
        var photoswipeContainer = document.querySelector(".pswp");
        this.photoSwipeInstance = new PhotoSwipe(
            photoswipeContainer,
            false,
            items,
            {
                index: selectedImageIndex,
                showHideOpacity: true,
                showAnimationDuration: 500,
                loop: false,
                history: false,
                closeOnVerticalDrag: true,
                allowPanToNext: false,
                pinchToClose: false,
                errorMsg: '<p class="pswp__error-msg"></p>',
                scaleMode: "orig",
                getDoubleTapZoom: function getDoubleTapZoom(isMouseClick, item) {
                    if (isMouseClick) {
                        return 1.35;
                    } else {
                        return item.initialZoomLevel < 0.7 ? 1 : 1.33;
                    }
                },
                getThumbBoundsFn: function getThumbBoundsFn(index) {
                    var allThumbnail = _this.element.querySelectorAll(
                            ".mainSwiper .ProductSliderCell--Zoom img"
                        ),
                        thumbnail = allThumbnail[index],
                        pageYScroll =
                            window.pageYOffset || document.documentElement.scrollTop,
                        rect = thumbnail.getBoundingClientRect();
                    return {x: rect.left, y: rect.top + pageYScroll, w: rect.width};
                },
            }
        );

        this.photoSwipeInstance.listen(
            "beforeChange",
            this.onslideChanged.bind(this)
        );
        this.photoSwipeInstance.listen(
            "destroy",
            this.destroyPhotoSwipe.bind(this)
        );
        this.photoSwipeInstance.listen("doubleTap", this.onDoubleTap.bind(this));
        this.photoSwipeInstance.listen(
            "initialZoomIn",
            this.onInitialZoomIn.bind(this)
        );
        this.photoSwipeInstance.listen(
            "initialZoomOut",
            this.onInitialZoomOut.bind(this)
        );

        this.delegateRoot.on(
            "pswpTap",
            ".pswp__scroll-wrap",
            this.onSingleTap.bind(this)
        );
        this.delegateRoot.on(
            "pswpTap",
            ".pswp__button--close",
            this.photoSwipeInstance.close
        );
        this.delegateRoot.on(
            "pswpTap",
            ".pswp__button--prev",
            this.photoSwipeInstance.prev
        );
        this.delegateRoot.on(
            "pswpTap",
            ".pswp__button--next",
            this.photoSwipeInstance.next
        );
        this.photoSwipeInstance.listen("close", this.photoswiperClose.bind(this));
        if (/iPhone|iPad|iPod/i.test(window.navigator.userAgent)) {
            document.documentElement.classList.add("pswp-open-in-ios");
        }
        this.photoSwipeInstance.init();
    }

    onslideChanged() {
        if (this.photoSwipeInstance.getCurrentIndex() === 0) {
            this.photoSwipeInstance.scrollWrap
                .querySelector(".pswp__button--prev")
                .setAttribute("disabled", "disabled");
        } else {
            this.photoSwipeInstance.scrollWrap
                .querySelector(".pswp__button--prev")
                .removeAttribute("disabled");
        }

        if (
            this.photoSwipeInstance.getCurrentIndex() + 1 ===
            this.photoSwipeInstance.options.getNumItemsFn()
        ) {
            this.photoSwipeInstance.scrollWrap
                .querySelector(".pswp__button--next")
                .setAttribute("disabled", "disabled");
        } else {
            this.photoSwipeInstance.scrollWrap
                .querySelector(".pswp__button--next")
                .removeAttribute("disabled");
        }
    }

    onSingleTap(event) {
        if (!event.detail || event.detail.pointerType === "mouse") {
            if (event.target.classList.contains("pswp__img")) {
                this.photoSwipeInstance.toggleDesktopZoom(event.detail.releasePoint);
            }
        } else {
            if (event.target.classList.contains("pswp__button")) {
                return;
            }

            event.target
                .closest(".pswp")
                .querySelector(".pswp__ui")
                .classList.toggle("pswp__ui--hidden");
        }
    }

    onDoubleTap(point) {
        var initialZoomLevel = this.photoSwipeInstance.currItem.initialZoomLevel;

        if (this.photoSwipeInstance.getZoomLevel() !== initialZoomLevel) {
            this.photoSwipeInstance.zoomTo(initialZoomLevel, point, 333);
        } else {
            this.photoSwipeInstance.zoomTo(
                initialZoomLevel < 0.7 ? 1 : 1.33,
                point,
                333
            );
        }
    }

    onInitialZoomIn() {
        document.querySelector(".pswp__ui").classList.remove("pswp__ui--hidden");
    }

    onInitialZoomOut() {
        document.querySelector(".pswp__ui").classList.add("pswp__ui--hidden");
    }

    destroyPhotoSwipe() {
        this.delegateRoot.off("pswpTap");
        this.photoSwipeInstance = null;
    }
}

class RevolutionSelectbox {
    constructor(element, popover, additionalOverlay) {
        this.element = element;
        this.popover = popover;
        this.changeOverlay = additionalOverlay;
        this.domDelegate = new Delegate(this.element);
        this.delegateBody = new Delegate(document.body);
        this.dropdown = this.element.querySelector(".RevolutionDropdown");
        this.mainDropdown = this.element.querySelector(
            ".RevolutionDropdown--Content"
        );

        this.mainDropdownContent = this.element.querySelector(
            ".RevolutionDropdown--InnerContent"
        );
        this.mainButton = this.element.querySelector(".RevolutionDropdown--Button");

        this.connectedSelect = this.element.getAttribute("data-select");
        this.selectbox = this.element.querySelector(
            "[name=" + this.connectedSelect + "]"
        );
        if (this.selectbox == null) {
            this.selectbox = this.element.querySelector(
                "[name2=" + this.connectedSelect + "]"
            );
        }
        if (this.popover == true) {
            this.mainDropdown.classList.add("PopoverContent");
            if (this.changeOverlay) {
                this.pageOverlayElement = document.querySelector(
                    ".localizationOverlay"
                );
            } else {
                this.pageOverlayElement = document.querySelector(".pageOverlay");
            }
        }
        this.bindEvents();
        this.initSelectbox();
    }

    bindEvents() {
        this.onClickOutsideListener = this.onClickOutside.bind(this);
        this.domDelegate.on(
            "click",
            "[data-action=toggle-selectbox]",
            this.toggleDropdown.bind(this)
        );

        this.domDelegate.on(
            "click",
            "[data-action=selectbox-submit]",
            this.selectboxSubmit.bind(this)
        );
        this.domDelegate.on(
            "keypress",
            "[data-action=selectbox-submit]",
            this.selectboxSubmit.bind(this)
        );

        this.domDelegate.on(
            "click",
            "[data-action=selectbox-change]",
            this.selectboxChange.bind(this)
        );

        this.delegateBody.on("menu:open", this.onClickOutside.bind(this));
        this.domDelegate.on("click", "body", this.onClickOutside.bind(this));
    }

    selectboxChange() {
        var value = event.target.getAttribute("data-value");
        var selectboxID = event.target.getAttribute("data-selectboxid");
        var innerContent = event.target.innerHTML;
        var selEl = this.element.querySelector("#" + selectboxID);
        if (selEl.nodeName == "SELECT") {
            selEl.value = value;
            selEl.dispatchEvent(new Event("change"));
        } else if (selEl.nodeName == "INPUT") {
            selEl.value = value;
            event.target
                .closest(".RevolutionDropdown")
                .querySelector('[selected="selected"]')
                .removeAttribute("selected");
            event.target.setAttribute("selected", "selected");
            selEl.dispatchEvent(new Event("change"));
        } else {
            selEl
                .querySelector('[value="' + value + '"]')
                .setAttribute("checked", "true");
        }
        this.mainButton.querySelector(".RevolutionDropdown--Title").innerHTML =
            innerContent;
        this.closeDropdown(this.element);
    }

    onClickOutside(event) {
        const withinBoundaries = event.composedPath().includes(this.element);
        if (
            !withinBoundaries ||
            event.target.classList.contains("FiltersDesktopWrapper")
        ) {
            this.closeDropdown(this.element);
        }
    }

    selectboxSubmit(event, target) {
        if (event.key != "Enter" && event.key !== undefined) {
            return;
        }
        var value = event.target.getAttribute("data-value");
        var dataName = event.target.getAttribute("data-name");
        this.selectbox.value = value;
        this.closeDropdown(this.element);
        this.mainButton.querySelector(".RevolutionDropdown--Title").innerHTML =
            dataName;
        this.selectbox.parentElement.submit();
    }

    initSelectbox() {
        var selectedItem = this.mainDropdown.querySelector('[selected="selected"]'),
            titleElement = this.element.querySelector(".RevolutionDropdown--Title");
        if (selectedItem) {
            titleElement.innerHTML = selectedItem.getAttribute("data-name");
        }

        trapFocus(this.element);
        this.element.style.display = "block";
    }

    toggleDropdown(event, target) {
        event.preventDefault();
        var isOpen = target.getAttribute("aria-expanded") === "true";
        if (isOpen) {
            this.closeDropdown(target);
        } else {
            this.openDropdown(target);
        }
    }

    openDropdown(target) {
        this.element.dispatchEvent(
            new CustomEvent("close:search", {bubbles: true})
        );
        this.element.dispatchEvent(
            new CustomEvent("resize:swiper", {bubbles: true})
        );
        var siblings = new DomHelper().getSiblings(
            target.parentElement,
            ".RevolutionDropdown"
        );
        siblings.forEach(function (item) {
            item
                .querySelector(".RevolutionDropdown--Button")
                .setAttribute("aria-expanded", false);
            item
                .querySelector(".RevolutionDropdown--Content")
                .setAttribute("aria-hidden", true);
            item.querySelector(".RevolutionDropdown--Content").style.display = "none";
        });

        if (this.popover == true) {
            this.pageOverlayElement.classList.add("is-visible");
            this.pageOverlayElement.addEventListener(
                "click",
                this.onClickOutsideListener
            );
            var focus = this.element.querySelector("[data-scrollable]");
            bodyScrollLock.disableBodyScroll(focus, bodyScrollLockOptions);
            document.body.classList.add("scrollLock");
            trapFocus(this.mainDropdown);
            if (
                document
                    .querySelector("#sidebarDrawer")
                    .getAttribute("aria-expanded") == "true"
            ) {
                document.querySelector(".SidebarDrawer--Wrapper").style.overflow =
                    "visible";
            }
        } else {
            this.element.dispatchEvent(
                new CustomEvent("menu:close", {bubbles: true})
            );
        }


        target.setAttribute("aria-expanded", true);
        target.parentElement
            .querySelector(".RevolutionDropdown--Content")
            .setAttribute("aria-hidden", false);
        target.parentElement.querySelector(
            ".RevolutionDropdown--Content"
        ).style.display = "block";
        window.addEventListener("click", this.onClickOutsideListener);
    }

    closeDropdown(target) {
        this.element.dispatchEvent(
            new CustomEvent("resize:swiper", {bubbles: true})
        );
        var closestDropdown = target.closest(".RevolutionDropdown");
        if (closestDropdown === null) {
            var closestDropdown = target.querySelector(
                "[aria-expanded='true']"
            ).parentElement;
        }
        closestDropdown
            .querySelector(".RevolutionDropdown--Button")
            .setAttribute("aria-expanded", false);
        closestDropdown
            .querySelector(".RevolutionDropdown--Content")
            .setAttribute("aria-hidden", true);
        setTimeout(() => {
            closestDropdown.querySelector(
                ".RevolutionDropdown--Content"
            ).style.display = "none";
        }, 300);
        if (this.popover == true) {
            this.pageOverlayElement.classList.remove("is-visible");
            this.pageOverlayElement.removeEventListener(
                "click",
                this.onClickOutsideListener
            );

            const menuDrawer = document.querySelector("#sidebarDrawer");
            if (menuDrawer.getAttribute("aria-expanded") == "true") {
                document.querySelector(".SidebarDrawer--Wrapper").style.overflow =
                    "auto";
            } else {
                bodyScrollLock.clearAllBodyScrollLocks();
                document.body.classList.remove("scrollLock");
            }
        }
        removeTrapFocus(this.mainDropdownContent);
        window.removeEventListener("click", this.onClickOutsideListener);
    }
}

class Form {
    constructor() {
    }

    serialize(form) {
        function stringKey(key, value) {
            var beginBracket = key.lastIndexOf("[");

            if (beginBracket === -1) {
                var _hash = {};
                _hash[key] = value;
                return _hash;
            }

            var newKey = key.substr(0, beginBracket);
            var newValue = {};

            newValue[key.substring(beginBracket + 1, key.length - 1)] = value;

            return stringKey(newKey, newValue);
        }

        var hash = {};

        for (var i = 0, len = form.elements.length; i < len; i++) {
            var formElement = form.elements[i];

            if (formElement.name === "" || formElement.disabled) {
                continue;
            }

            if (
                formElement.name &&
                !formElement.disabled &&
                (formElement.checked ||
                    /select|textarea/i.test(formElement.nodeName) ||
                    /hidden|text|search|tel|url|email|password|datetime|date|month|week|time|datetime-local|number|range|color/i.test(
                        formElement.type
                    ))
            ) {
                var stringKeys = stringKey(formElement.name, formElement.value);
                hash = this.extend(hash, stringKeys);
            }
        }

        return hash;
    }

    extend() {
        var extended = {},
            i = 0,
            _this = this;

        // Merge the object into the extended object
        var merge = function merge(obj) {
            for (var prop in obj) {
                if (obj.hasOwnProperty(prop)) {
                    // If property is an object, merge properties
                    if (Object.prototype.toString.call(obj[prop]) === "[object Object]") {
                        extended[prop] = _this.extend(extended[prop], obj[prop]);
                    } else {
                        extended[prop] = obj[prop];
                    }
                }
            }
        };

        // Loop through each object and conduct a merge
        for (; i < arguments.length; i++) {
            merge(arguments[i]);
        }

        return extended;
    }
}

class AddToCart {
    constructor(element) {
        this.element = element;
        this.delegateElement = new Delegate(this.element);
        this.pageLoader = document.body.querySelector(".pageLoader");
        this.bindEvents();
    }

    bindEvents() {
        this.delegateElement.on(
            "click",
            "[data-action=add-to-cart]",
            this.addToCart.bind(this)
        );

        this.delegateElement.on(
            "submit",
            'form[action="/cart/addall"]',
            this.addAllToCart.bind(this)
        );
        this.delegateElement.on(
            "click",
            "[data-action=add-all-to-cart]",
            this.addAllToCart.bind(this)
        );
    }

    addAllToCart(event) {
        var _this = this;
        event.preventDefault(); // Prevent form to be submitted

        var addToCartButton = this.element.querySelector(".AddToCartAjax");

        // First, we switch the status of the button
        addToCartButton.setAttribute("disabled", "disabled");
        document.dispatchEvent(new CustomEvent("theme:loading:start"));

        // Then we add the product in Ajax
        var formElement = event.target.closest("form");
        var formHelper = new Form();
        const formElementSerialized = formHelper.serialize(formElement);
        const items = [];
        const keys = Object.keys(formElementSerialized);

        var quant = 1;
        let discount = "";
        keys.forEach((key) => {
            if (key != "event_id") {
                let productID = document.body.querySelector('[name="' + key + '"]').dataset.id;

                if (productID) {
                    quant = document.body.querySelector("#quantity--id_" + productID);
                    if (quant) {
                        quant = quant.getAttribute("value");
                    } else {
                        quant = 1;
                    }
                }
                let discountName = "";
                let discountValue = 0;
                let discountEl = "";
                if (productID) {
                    discountEl = document.body.querySelector("#properties--id_" + productID);
                    if (discountEl) {

                        discountValue = discountEl.getAttribute("value");
                        discountName = discountEl.dataset.name;

                    }
                }

                if (productID) {
                    items.push({
                        id: productID,
                        quantity: quant,
                        properties: {
                            [discountName]: discountValue
                        }
                    });
                }
            }
        });

        fetch("/cart/add.js", {
            body: JSON.stringify({
                items: items,
            }),
            credentials: "same-origin",
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "X-Requested-With": "XMLHttpRequest", // This is needed as currently there is a bug in Shopify that assumes this header
            },
        }).then(function (response) {
            if (response.ok) {
                addToCartButton.removeAttribute("disabled");
                // We simply trigger an event so the mini-cart can re-render
                _this.element.dispatchEvent(
                    new CustomEvent("product:added", {
                        bubbles: true,
                        detail: {
                            variant: _this.currentVariant,
                            quantity: keys.length,
                        },
                    })
                );
            } else {
                response.json().then(function (content) {
                    var errorMessageElement = document.createElement("span");
                    errorMessageElement.className =
                        "ProductForm__Error Alert Alert--error u-p4";
                    errorMessageElement.innerHTML = content["description"];
                    addToCartButton.removeAttribute("disabled");
                    addToCartButton.insertAdjacentElement(
                        "afterend",
                        errorMessageElement
                    );
                    setTimeout(function () {
                        errorMessageElement.remove();
                    }, 2500);
                });
            }
        });

        event.preventDefault();
    }

    addToCart() {
        var _this = this;
        event.preventDefault();
        var addToCartButton = event.target;
        this.pageLoader.style.width = 100 + "%";
        addToCartButton.setAttribute("disabled", "disabled");
        var formElement = event.target.closest("form");
        formElement.querySelector('[name="id"]').removeAttribute("disabled");
        var formHelper = new Form();
        const serialized = formHelper.serialize(formElement);
        console.log(serialized)
        fetch(window.routes.localeRootUrl + "/cart/add.js", {
            body: JSON.stringify(serialized),
            credentials: "same-origin",
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "X-Requested-With": "XMLHttpRequest",
            },
        }).then(function (response) {
            if (response.ok) {
                if (window.location.href.indexOf("cart") != -1) {
                    location.reload();
                    return;
                }
                addToCartButton.removeAttribute("disabled");
                _this.element.dispatchEvent(
                    new CustomEvent("product:added", {
                        bubbles: true,
                        detail: {
                            variant: serialized.id,
                            quantity: serialized.quantity,
                        },
                    })
                );
            } else {
                response.json().then(function (content) {
                    if (_this.element.querySelector(".ProductForm--Error")) {
                        _this.element
                            .querySelector(".ProductForm--Error")
                            .classList.add("visible");
                        setTimeout(function () {
                            _this.element
                                .querySelector(".ProductForm--Error")
                                .classList.remove("visible");
                        }, 2500);
                        _this.pageLoader.style.left = "unset";
                        _this.pageLoader.style.right = 0 + "px";
                        _this.pageLoader.style.width = 0 + "%";
                        setTimeout(() => {
                            _this.pageLoader.style.left = 0 + "px";
                            _this.pageLoader.style.right = "unset";
                        }, 550);
                    } else {
                        var errorMessageElement = document.createElement("span");
                        errorMessageElement.className = "u-p4 accent";
                        errorMessageElement.innerHTML = content["description"];
                        addToCartButton.removeAttribute("disabled");
                        addToCartButton.insertAdjacentElement(
                            "afterend",
                            errorMessageElement
                        );
                        setTimeout(function () {
                            errorMessageElement.remove();
                        }, 2500);
                        _this.pageLoader.style.left = "unset";
                        _this.pageLoader.style.right = 0 + "px";
                        _this.pageLoader.style.width = 0 + "%";
                        setTimeout(() => {
                            _this.pageLoader.style.left = 0 + "px";
                            _this.pageLoader.style.right = "unset";
                        }, 550);
                    }
                });
            }
        });
    }
}

class Dropdown {
    constructor(element) {
        this.element = element;
        this.domDelegate = new Delegate(this.element);
        this.bindEvents();
    }

    bindEvents() {
        this.domDelegate.on(
            "click",
            "[data-action=toggle-dropdown]",
            this.toggleDropdown.bind(this)
        );
    }

    openDropdown(elem) {
        const dropdownButton = elem.querySelector(".DropdownButton"),
            dropdownContent = elem.querySelector(".DropdownContent");

        dropdownButton.setAttribute("aria-expanded", true);
        new RevolutionAnimation(dropdownContent, "true").slideDown();
    }

    closeDropdown(elem) {
        const dropdownButton = elem.querySelector(".DropdownButton"),
            dropdownContent = elem.querySelector(".DropdownContent");
        new RevolutionAnimation(dropdownContent, true).slideUp();
        dropdownButton.setAttribute("aria-expanded", false);
        setTimeout(function () {
            dropdownContent.setAttribute("aria-hidden", "true");
        }, 250);
    }

    toggleDropdown(event, target) {
        event.preventDefault(event);
        const mainDropdown = target.closest(".Dropdown");
        var isOpen = target.getAttribute("aria-expanded") === "true";

        if (isOpen) {
            this.closeDropdown(mainDropdown, target);
        } else {
            this.openDropdown(mainDropdown, target);
        }
    }
}

(function (funcName, baseObj) {
    "use strict";
    // The public function name defaults to window.docReady
    // but you can modify the last line of this function to pass in a different object or method name
    // if you want to put them in a different namespace and those will be used instead of
    // window.docReady(...)
    funcName = funcName || "docReady";
    baseObj = baseObj || window;
    var readyList = [];
    var readyFired = false;
    var readyEventHandlersInstalled = false;

    // call this when the document is ready
    // this function protects itself against being called more than once
    function ready() {
        if (!readyFired) {
            // this must be set to true before we start calling callbacks
            readyFired = true;
            for (var i = 0; i < readyList.length; i++) {
                // if a callback here happens to add new ready handlers,
                // the docReady() function will see that it already fired
                // and will schedule the callback to run right after
                // this event loop finishes so all handlers will still execute
                // in order and no new ones will be added to the readyList
                // while we are processing the list
                readyList[i].fn.call(window, readyList[i].ctx);
            }
            // allow any closures held by these functions to free
            readyList = [];
        }
    }

    function readyStateChange() {
        if (document.readyState === "complete") {
            ready();
        }
    }

    // This is the one public interface
    // docReady(fn, context);
    // the context argument is optional - if present, it will be passed
    // as an argument to the callback
    baseObj[funcName] = function (callback, context) {
        if (typeof callback !== "function") {
            throw new TypeError("callback for docReady(fn) must be a function");
        }
        // if ready has already fired, then just schedule the callback
        // to fire asynchronously, but right away
        if (readyFired) {
            setTimeout(function () {
                callback(context);
            }, 1);
            return;
        } else {
            // add the function and context to the list
            readyList.push({fn: callback, ctx: context});
        }
        // if document already ready to go, schedule the ready function to run
        // IE only safe when readyState is "complete", others safe when readyState is "interactive"
        if (
            document.readyState === "complete" ||
            (!document.attachEvent && document.readyState === "interactive")
        ) {
            setTimeout(ready, 1);
        } else if (!readyEventHandlersInstalled) {
            // otherwise if we don't have event handlers installed, install them
            if (document.addEventListener) {
                // first choice is DOMContentLoaded event
                document.addEventListener("load", ready, false);
                // backup is window load event
                window.addEventListener("DOMContentLoaded", ready, false);
            } else {
                // must be IE
                document.attachEvent("onreadystatechange", readyStateChange);
                window.attachEvent("onload", ready);
            }
            readyEventHandlersInstalled = true;
        }
    };
})("docReady", window);
// modify this previous line to pass in your own method name
// and object for the method to be attached to

/*GLOBAL FUNCTIONS */

function handleFirstTab(e) {
    if (e.keyCode === 9) {
        document.body.classList.add("user-is-tabbing");

        window.removeEventListener("keydown", handleFirstTab);
        window.addEventListener("mousedown", handleMouseDownOnce);
    }
}

function handleMouseDownOnce() {
    document.body.classList.remove("user-is-tabbing");

    window.removeEventListener("mousedown", handleMouseDownOnce);
    window.addEventListener("keydown", handleFirstTab);
}

window.addEventListener("keydown", handleFirstTab);

function getFocusableElements(container) {
    return Array.from(
        container.querySelectorAll(
            "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe, .focusable"
        )
    );
}

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
    var elements = getFocusableElements(container);
    var first = elements[0];
    var last = elements[elements.length - 1];

    removeTrapFocus();

    trapFocusHandlers.focusin = (event) => {
        if (
            event.target !== container &&
            event.target !== last &&
            event.target !== first
        )
            return;

        document.addEventListener("keydown", trapFocusHandlers.keydown);
    };

    trapFocusHandlers.focusout = function () {
        document.removeEventListener("keydown", trapFocusHandlers.keydown);
    };

    trapFocusHandlers.keydown = function (event) {
        if (event.code.toUpperCase() !== "TAB") return; // If not TAB key
        // On the last focusable element and tab forward, focus the first element.
        if (event.target === last && !event.shiftKey) {
            event.preventDefault();
            first.focus();
        }

        //  On the first focusable element and tab backward, focus the last element.
        if (
            (event.target === container || event.target === first) &&
            event.shiftKey
        ) {
            event.preventDefault();
            last.focus();
        }
    };

    document.addEventListener("focusout", trapFocusHandlers.focusout);
    document.addEventListener("focusin", trapFocusHandlers.focusin);
    if (first) {
        first.focus();
    } else {
        elementToFocus.focus();
    }
}

function removeTrapFocus(elementToFocus = null) {
    document.removeEventListener("focusin", trapFocusHandlers.focusin);
    document.removeEventListener("focusout", trapFocusHandlers.focusout);
    document.removeEventListener("keydown", trapFocusHandlers.keydown);

    if (elementToFocus) elementToFocus.focus();
}

class DomHelper {
    constructor() {
    }

    getSiblings(element, filter) {
        var includeSelf =
            arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

        var siblings = [];
        var currentElement = element;

        // Do the previous first
        while ((currentElement = currentElement.previousElementSibling)) {
            if (!filter || currentElement.matches(filter)) {
                siblings.push(currentElement);
            }
        }

        if (includeSelf) {
            siblings.push(element);
        }

        // Then the next side
        currentElement = element;

        while ((currentElement = currentElement.nextElementSibling)) {
            if (!filter || currentElement.matches(filter)) {
                siblings.push(currentElement);
            }
        }

        return siblings;
    }

    nodeListToArray(nodeList, filter) {
        var items = [];

        for (var i = 0; i !== nodeList.length; ++i) {
            if (!filter || nodeList[i].matches(filter)) {
                items.push(nodeList[i]);
            }
        }

        return items;
    }

    outerWidthWithMargin(element) {
        var width = element.offsetWidth,
            style = getComputedStyle(element);

        width += parseInt(style.marginLeft) + parseInt(style.marginRight);

        return width;
    }

    outerHeightWithMargin(element) {
        var height = element.offsetHeight,
            style = getComputedStyle(element);

        height += parseInt(style.marginTop) + parseInt(style.marginBottom);

        return height;
    }
}

class Responsive {
    constructor() {
        var _this = this;

        this.currentBreakpoint = this.getCurrentBreakpoint();

        window.addEventListener("resize", function () {
            var newBreakpoint = _this.getCurrentBreakpoint();

            if (_this.currentBreakpoint === newBreakpoint) {
                return;
            }

            document.dispatchEvent(
                new CustomEvent("breakpoint:changed", {
                    detail: {
                        previousBreakpoint: _this.currentBreakpoint,
                        currentBreakpoint: newBreakpoint,
                    },
                })
            );

            _this.currentBreakpoint = newBreakpoint;
        });
    }

    matchesBreakpoint(breakpoint) {
        switch (breakpoint) {
            case "phone":
                return window.matchMedia("screen and (max-width: 640px)").matches;

            case "tablet":
                return window.matchMedia(
                    "screen and (min-width: 641px) and (max-width: 1024px)"
                ).matches;

            case "tablet-and-up":
                return window.matchMedia("screen and (min-width: 768px)").matches;

            case "pocket":
                return window.matchMedia("screen and (max-width: 1024px)").matches;

            case "lap-and-up":
                return window.matchMedia("screen and (min-width: 1025px)").matches;

            case "desk":
                return window.matchMedia("screen and (min-width: 1280px)").matches;
        }
    }

    getCurrentBreakpoint() {
        if (window.matchMedia("screen and (max-width: 640px)").matches) {
            return "phone";
        }

        if (
            window.matchMedia("screen and (min-width: 641px) and (max-width: 1024px)")
                .matches
        ) {
            return "tablet";
        }

        if (
            window.matchMedia(
                "screen and (min-width: 1008px) and (max-width: 1279px)"
            ).matches
        ) {
            return "lap";
        }

        if (window.matchMedia("screen and (min-width: 1280px)").matches) {
            return "desk";
        }
    }
}

class RevolutionImage {
    constructor() {
    }

    getSizedImageUrl(src, size) {
        if (size === null) {
            return src;
        }

        if (size === "master") {
            return src.replace(/http(s)?:/, "");
        }

        var match = src.match(
            /\.(jpg|jpeg|gif|webp|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i
        );

        if (match) {
            var prefix = src.split(match[0]);
            var suffix = match[0];

            return (prefix[0] + "_" + size + suffix).replace(/http(s)?:/, "");
        } else {
            return null;
        }
    }

    getSupportedSizes(image, desiredSizes) {
        var supportedSizes = [],
            imageWidth = image["width"];

        desiredSizes.forEach(function (width) {
            if (imageWidth >= width) {
                supportedSizes.push(width);
            }
        });

        return supportedSizes;
    }
}

class RevolutionSwiper {
    constructor(element, additionalSwiper) {
        var options =
            arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        this.element = element;
        this.thumb = additionalSwiper;
        this.initialConfig = JSON.parse(
            element.getAttribute("data-swiper-settings")
        );

        if (additionalSwiper) {
            this.initialConfigThumbs = JSON.parse(
                additionalSwiper.getAttribute("data-swiper-thumb-settings")
            );
        }
        this.options = options;
        this.build();
    }

    selectCell(index) {
        this.swiperElement.slideTo(index);
    }

    resize() {
        this.swiperElement.update();
    }

    build() {
        var _this = this,
            configThumb = this.initialConfigThumbs;
        if (configThumb != null) {
            this.thumbSwiper = new Swiper(this.thumb, configThumb);
            this.initialConfig.thumbs["swiper"] = this.thumbSwiper;
        }
        this.swiperElement = new Swiper(this.element, this.initialConfig);
        this.selectedIndex = this.swiperElement.activeIndex;

        this.swiperElement.on("slideChange", function () {
            _this.element.dispatchEvent(
                new CustomEvent("swiper:slide-changed", {
                    bubbles: true,
                    detail: {
                        currentIndex: _this.swiperElement.activeIndex,
                        element: _this.swiperElement.$el[0],
                    },
                })
            );
        });
    }
}

class Drawer {
    constructor(element) {
        var options =
            arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        this.element = element;
        this.delegateElement = new Delegate(this.element);
        this.delegateBody = new Delegate(document.body);
        this.pageOverlayElement = document.querySelector(".pageOverlay");

        if (navigator.platform === "iPhone")
            document.documentElement.style.setProperty(
                "--viewport-height",
                `${window.innerHeight}px`
            );
        this.onOpen = options["onOpen"] || function () {
        };
        this.onClose = options["onClose"] || function () {
        };
        this.isOpen = false;

        this.bindEvents();
    }

    bindEvents() {
        this.delegateBody.on(
            "click",
            '[data-action="open-drawer"][data-toggle-id="' + this.element.id + '"]',
            this.openDrawer.bind(this)
        );
        this.delegateBody.on(
            "click",
            '[data-action="close-drawer"][data-toggle-id="' + this.element.id + '"]',
            this.closeDrawer.bind(this)
        );
        this.delegateBody.on(
            "click",
            '[data-action="toggle-drawer"][data-toggle-id="' + this.element.id + '"]',
            this.toggleDrawer.bind(this)
        );
        this._openListener = this.openDrawer.bind(this);
        this._closeListener = this.closeDrawer.bind(this);
        this.calculateMaxHeightListener = this.maxHeight.bind(this);
        window.addEventListener("resize", this.calculateMaxHeightListener);

        this.delegateBody.on("cart-drawer:close-other", this._closeListener);
        this.delegateBody.on("menu:close", this._closeListener);
    }

    maxHeight() {
        const id = this.element.getAttribute("id");
        if (id == "quantityDrawer") {
            return;
        }
        this.element.style.height = window.innerHeight + "px";
        if (id == "cart" || id == "sidebarFavorites") {
            var footer = this.element.querySelector(".CartDrawer--Footer");
            var footerHeight = 0;
            if (footer !== null) {
                footerHeight = footer.offsetHeight;
            }

            var header = this.element.querySelector(".CartHeader").offsetHeight;
            var cartItem = this.element.querySelector(".cartItem");
            if (cartItem !== null) {
                var itemHeight = cartItem.offsetHeight;
            }

            var itemWrapper = this.element.querySelector(".CartItems--Wrapper");

            if (itemWrapper !== null) {
                itemWrapper.style.height =
                    window.innerHeight - footerHeight - header + "px";
            }
        } else if (id == "sidebarDrawer") {
            var mobileHeader = document.querySelector(".header");
            var mobileHeaderHeight = mobileHeader.offsetHeight;
            this.element.style.height =
                window.innerHeight - mobileHeaderHeight + "px";
        } else {
            var filterBar = document.querySelector(".FilterBar");
            var mobileHeader = document.querySelector(".header");
            var breakpoint = new Responsive().getCurrentBreakpoint();

            if (filterBar !== null && breakpoint == "phone") {
                var filterBarHeight = filterBar.offsetHeight;
                var mobileHeaderHeight = mobileHeader.offsetHeight;

                this.element.style.height =
                    window.innerHeight - mobileHeaderHeight - filterBarHeight + 1 + "px";
            }
        }
    }

    toggleDrawer() {
        event.preventDefault();
        this.isOpen ? this.closeDrawer() : this.openDrawer();
    }

    openDrawer() {
        this.maxHeight();
        var drawerId = this.element.getAttribute("id");
        this.element.dispatchEvent(
            new CustomEvent("close:search", {bubbles: true})
        );

        if (drawerId == "cart") {
            this.element.dispatchEvent(
                new CustomEvent("cart-drawer:open", {bubbles: true})
            );
            if (this.element.querySelector(".emptyItem--Text")) {
                this.element.querySelector(".emptyItem--Text").style.display = "flex";
            }

            setTimeout(() => {
                var count = window.theme.cartCount;
                var options = JSON.parse(this.element.getAttribute("data-settings"));
            }, 200);
        }
        if (this.isOpen) {
            return;
        }

        this.element.dispatchEvent(
            new CustomEvent("cart-drawer:close-other", {bubbles: true})
        );

        this.maxHeight();

        if (drawerId == "sidebarDrawer") {
            if (document.querySelector(".SidebarDrawer__Close")) {
                document.querySelector(".SidebarDrawer__Close").style.display = "block";
            }

            document.body.querySelector("#shopify-section-header").style.zIndex =
                "99";
            this.element.dispatchEvent(
                new CustomEvent("sidebar-drawer:open", {
                    bubbles: true,
                })
            );
        } else if (drawerId == "favoritesDrawer") {
            this.element.dispatchEvent(
                new CustomEvent("favorite-product:open", {
                    bubbles: true,
                })
            );
        } else if (drawerId == "FilterDrawer" || drawerId == "sortby") {
            document.querySelector(".FilterBar").style.zIndex = "99";
            document.body.querySelector("#shopify-section-header").style.zIndex =
                "99";
        }

        this.element.setAttribute("aria-expanded", "true");
        this.pageOverlayElement.classList.add("is-visible");
        this.pageOverlayElement.addEventListener("click", this._closeListener);

        var focus = this.element.querySelectorAll("[data-scrollable]");
        focus.forEach((item) => {
            bodyScrollLock.disableBodyScroll(item);
        });
        document.body.classList.add("scrollLock");
        this.isOpen = true;
        setTimeout(() => {
            trapFocus(this.element);
        }, 400);
        this.onOpen();
        return false;
    }

    closeDrawer(event) {
        if (!this.isOpen) {
            return;
        }

        var drawerId = this.element.getAttribute("id");
        if (event) {
            event.preventDefault();
        }

        if (
            drawerId == "favoritesDrawer" &&
            this.element.querySelector(".swiperFavorites--titleButtons")
        ) {
            this.element.querySelector(
                ".swiperFavorites--titleButtons"
            ).style.display = "none";
            if (this.element.querySelector(".favUpsell__Container")) {
                this.element.querySelector(".favUpsell__Container").remove();
            }
        }

        document.body.classList.remove("scrollLock");

        bodyScrollLock.clearAllBodyScrollLocks();
        if (drawerId == "cart") {
            var options = JSON.parse(this.element.getAttribute("data-settings"));
        }
        this.element.setAttribute("aria-expanded", "false");
        if (
            this.element.classList.contains("sizeDrawer_Wrapper") == true &&
            document.body.querySelector("#cart").getAttribute("aria-expanded") ==
            "true"
        ) {
            return;
        }

        if (
            drawerId == "FilterDrawer" ||
            drawerId == "sidebarDrawer" ||
            drawerId == "sortby"
        ) {
            document.body.querySelector("#shopify-section-header").style.zIndex = "6";
        }

        this.pageOverlayElement.classList.remove("is-visible");
        this.pageOverlayElement.removeEventListener("click", this._closeListener);
        removeTrapFocus(this.element);
        this.closeAnimation(this.element);
        this.isOpen = false;
        this.onClose();
    }

    closeAnimation(detailsElement) {
        let animationStart;

        const handleAnimation = (time) => {
            if (animationStart === undefined) {
                animationStart = time;
            }

            const elapsedTime = time - animationStart;

            if (elapsedTime < 400) {
                window.requestAnimationFrame(handleAnimation);
            } else {
                detailsElement.removeAttribute("open");
                if (detailsElement.closest("details[open]")) {
                    trapFocus(
                        detailsElement.closest("details[open]"),
                        detailsElement.querySelector("summary")
                    );
                }
            }
        };

        window.requestAnimationFrame(handleAnimation);
    }
}

class FavoritesDrawer extends HTMLElement {
    constructor() {
        super();
        this.element = this;
        this.delegateElement = new Delegate(this.element);
        this.sidebarDrawer = new Drawer(this.element);
        this.delegateBody = new Delegate(document.body);
        this.options = JSON.parse(this.element.getAttribute("data-settings"));
        this.loader = this.element.querySelector(".loader");
        this.cartCount = document.querySelector(".FavoritesCount");

        this.toggleFavorites();
        this.bindEvents();
    }

    unbindEvents() {
        document.removeEventListener(
            "favorite-product:open",
            this.onFavoritesOpenListener
        );

        document.removeEventListener("click", this._addToFavoritesL);
    }

    bindEvents() {
        if (!document.body.classList.contains("listener")) {
            this.onFavoritesOpenListener = this.onFavoritesOpen.bind(this);
            this._addToFavoritesL = this.addToFavorites.bind(this);
            this.delegateBody.on(
                "click",
                '[data-action="toggle-favorites"]',
                this._addToFavoritesL
            );
            document.body.classList.add("listener");
            document.addEventListener(
                "favorite-product:open",
                this.onFavoritesOpenListener
            );

            document.addEventListener(
                "favorites:toggle",
                this.toggleFavorites.bind(this)
            );
        }
    }

    onFavoritesOpen() {
        var _this = this;

        this.rerenderFavorites().then(function () {
            new AddToCart(_this.element);
        });
        this.sidebarDrawer.isOpen = true;
    }

    maxHeight() {
        var footer = this.element.querySelector(".CartDrawer--Footer");
        if (footer) {
            var footerH = footer.offsetHeight;
        }

        this.element.querySelector(".CartItems--Wrapper").style.height =
            window.innerHeight - footerH + "px";
    }

    getSearchQueryStrings() {
        var items = JSON.parse(localStorage.getItem("productFavorites") || "[]");
        // If we are on a product template, we make sure to remove the main product from the related product
        const bucketSize = 10.0;
        const idBuckets = [];
        items.forEach((id, index) => {
            const key = Math.floor(index / bucketSize);
            if (!idBuckets[key]) {
                idBuckets[key] = [];
            }
            idBuckets[key].push(id);
        });
        return idBuckets.reduce((acc, vall) => {
            const string = vall
                .map(function (id) {
                    return "id:" + id;
                })
                .join(" OR ");

            acc.push(string);
            return acc;
        }, []);
    }

    rerenderFavorites(event, elementToAnimate) {
        this.loader.classList.add("is-visible");
        var _this32 = this;
        var queryStrings = this.getSearchQueryStrings();
        const promises = [];

        if (queryStrings.length == 0) {
            this.loader.classList.remove("is-visible");
            fetch("/?section_id=favorites-drawer").then(function (content) {
                content.text().then(function (html) {
                    _this32.replaceContentFav(html);
                    _this32.loadRecommendations();
                    _this32.loader.classList.remove("is-visible");
                });
            });
        }
        queryStrings.forEach((string) => {
            promises.push(
                fetch("/search?view=favorites&type=product&q=" + string, {
                    credentials: "same-origin",
                    method: "GET",
                })
            );
        });
        promises.reduce(async (acc, val, index) => {
            const content = await val.then((response) => response.text());
            const container = this.element;
            if (!container.length) {
                _this32.replaceContentFav(content);
                _this32.loader.classList.remove("is-visible");
                _this32.element.querySelector("#cartData").style.display = "block";
                _this32.maxHeight();
            } else {
                this.loader.classList.remove("is-visible");
            }
        }, Promise.resolve());

        return Promise.resolve();
    }

    replaceContentFav(html) {
        var tempElement = document.createElement("div");
        tempElement.innerHTML = html;
        var number = tempElement
            .querySelector(".countFav")
            .getAttribute("data-count");
        var cartNodeParent = this.element.querySelector(".CartDrawer");
        cartNodeParent.replaceChild(
            tempElement.querySelector("#cartData"),
            this.element.querySelector("#cartData")
        );
        this.toggleFavorites();

        this.loader.classList.remove("is-visible");
        var focus = this.element.querySelectorAll("[data-scrollable]");

        focus.forEach((item) => {
            bodyScrollLock.disableBodyScroll(item);
        });
        if (window.theme.enableImageAnimations) {
            new RevolutionAnimation(this.element);
        }
        return true;
    }

    toggleFavorites() {
        var items = JSON.parse(localStorage.getItem("productFavorites") || "[]");
        var favorites = document.querySelectorAll(".ProductCard--Favorites");
        if (document.body.querySelector(".emptyHearth")) {
            if (items.length > 0) {
                document.body.querySelector(".emptyHearth").style.display = "none";
                document.body.querySelector(".brokenHearth").style.display = "flex";
            } else {
                document.body.querySelector(".emptyHearth").style.display = "flex";
                document.body.querySelector(".brokenHearth").style.display = "none";
            }
        }
        favorites.forEach(function (item) {
            var state = item
                .querySelector(".ProductCard--FavoritesHolder")
                .getAttribute("state");
            var myID = item
                .querySelector(".ProductCard--FavoritesHolder")
                .getAttribute("data-id");

            if (state == "not-active" && items.includes(myID)) {
                item.querySelector(".brokenHearth").style.display = "flex";
                item.querySelector(".emptyHearth").style.display = "none";
                item
                    .querySelector(".ProductCard--FavoritesHolder")
                    .setAttribute("state", "active");
            } else if (!items.includes(myID)) {
                item.querySelector(".brokenHearth").style.display = "none";
                item.querySelector(".emptyHearth").style.display = "flex";
                item
                    .querySelector(".ProductCard--FavoritesHolder")
                    .setAttribute("state", "not-active");
            }
        });
    }

    removeFromFavorites(productId) {
        var items = JSON.parse(localStorage.getItem("productFavorites") || "[]");
        items = items.filter((c) => c != productId);

        try {
            localStorage.setItem(
                "productFavorites",
                JSON.stringify(items.slice(0, 50))
            );
        } catch (error) {

        }
        var _this = this;
        this.toggleFavorites();
        if (this.sidebarDrawer.isOpen == true) {
            this.rerenderFavorites().then(function () {
                new AddToCart(_this.element);
            });
        }
    }

    loadRecommendations() {
        if (this.options["productId"] == "") {
            var url = "?section_id=fav-recommendations";
        } else {
            var url =
                window.routes.localeRootUrl +
                "/recommendations/products?section_id=fav-recommendations&product_id=" +
                this.options["productId"] +
                "&limit=10";
        }

        var _this = this;

        return fetch(url).then(function (response) {
            return response.text().then(function (content) {
                var container = document.createElement("div");
                container.innerHTML = content;

                if (container) {
                    var z = container.querySelector(".favUpsell").innerHTML;
                    var x = _this.element.querySelector(".FavoritesRecommendations");
                    x.innerHTML = z;
                }

                const swiper = new Swiper(".swiperUpsell", {
                    // Default parameters
                    slidesPerView: 2,
                    spaceBetween: 16,
                    navigation: false,
                    loop: false,
                    slidesOffsetAfter: 0,
                    slidesOffsetBefore: 0,
                    navigation: {
                        nextEl: ".swiperNextFav",
                        prevEl: ".swiperPrevFav",
                    },
                    pagination: {
                        el: ".favoritePaginatio",
                        type: "progressbar",
                        clickable: true,
                    },
                    breakpoints: {
                        1024: {
                            slidesPerView: 2.345,
                            spaceBetween: 32,
                            slidesOffsetAfter: 32,
                            slidesOffsetBefore: 32,
                        },
                    },
                });
                new AddToCart(x);
                _this.toggleFavorites();

                if (window.theme.enableImageAnimations) {
                    new RevolutionAnimation(_this.element);
                }
                _this.element.querySelector("#cartData").style.display = "block";
            });
        });
    }

    addToFavorites(event) {
        var _this = this;
        event.preventDefault();
        var items = JSON.parse(localStorage.getItem("productFavorites") || "[]");
        var productId = event.target.getAttribute("data-id");

        // We check if the current product already exists, and if it does not, we add it at the start
        if (!items.includes(productId) && productId != "") {
            items.unshift(productId);
        } else {
            this.removeFromFavorites(productId, false);
            //   this._favoritesNumber();
            return;
        }
        // Then, we save the current product into the local storage, by keeping only the 50 most recent
        try {
            localStorage.setItem(
                "productFavorites",
                JSON.stringify(items.slice(0, 50))
            );
            //    this._favoritesNumber();
            this.toggleFavorites();
            if (this.sidebarDrawer.isOpen == true) {
                this.rerenderFavorites().then(function () {
                    new AddToCart(_this.element);
                });
            }
        } catch (error) {
            // Do nothing, this may happen in Safari in incognito mode
        }
    }
}

customElements.define("favorites-drawer", FavoritesDrawer);

class RevolutionAnimation {
    constructor(element, directAnimation) {
        this.element = element;
        if (!directAnimation) {
            this.intersectionObserver = [];
            var contentToAnimate = this.element.querySelectorAll("[data-animation]");
            contentToAnimate.forEach((item, i) => {
                this.setupAnimation(item, i);
            });
        }
    }

    slideUp() {
        this.element.style.height = this.element.scrollHeight + "px";
        this.element.offsetHeight;
        this.element.style.height = 0;
    }

    slideDown() {
        if (this.element.style.height === "auto") {
            return;
        }
        var _this = this;
        this.element.style.height = this.element.scrollHeight + "px";
        this.element.setAttribute("aria-hidden", false);
        var transitionEnded = function transitionEnded(event) {
            if (event.propertyName === "height") {
                _this.element.style.height = "auto";
                _this.element.removeEventListener("transitionend", transitionEnded);
            }
        };

        this.element.addEventListener("transitionend", transitionEnded);
    }

    elementScaleOut(toReveal) {
        toReveal.forEach((item, i) => {
            if (item.getAttribute("data-loaded")) {
                return;
            }
            setTimeout(() => {
                var elementMove = [
                    // keyframes
                    {transform: "scale(104%)", opacity: "0"},
                    {transform: "scale(100%)", opacity: "1"},
                ];
                item.animate(elementMove, {
                    // timing options
                    duration: window.theme.animationDuration * 2,
                    fill: "forwards",
                });
            }, window.theme.animationBetweenElements * i);
            item.setAttribute("data-loaded", true);
        });
    }

    elementScaleIn(toReveal) {
        toReveal.forEach((item, i) => {
            if (item.getAttribute("data-loaded")) {
                return;
            }
            setTimeout(() => {
                var elementMove = [
                    // keyframes
                    {transform: "scale(96%)", opacity: "0"},
                    {transform: "scale(100%)", opacity: "1"},
                ];
                item.animate(elementMove, {
                    // timing options
                    duration: window.theme.animationDuration * 2,
                    fill: "forwards",
                });
            }, window.theme.animationBetweenElements * i);
            item.setAttribute("data-loaded", true);
        });
    }

    elementFromTop(toReveal) {
        toReveal.forEach((item, i) => {
            if (item.getAttribute("data-loaded")) {
                return;
            }
            setTimeout(() => {
                var elementMove = [
                    // keyframes
                    {transform: "translateY(-30px)", opacity: "0"},
                    {transform: "translateY(0px)", opacity: "1"},
                ];
                item.animate(elementMove, {
                    // timing options
                    duration: window.theme.animationDuration,
                    fill: "forwards",
                });
            }, window.theme.animationBetweenElements * i);
            item.setAttribute("data-loaded", true);
        });
    }

    elementFromBottom(toReveal) {
        toReveal.forEach((item, i) => {
            if (item.getAttribute("data-loaded")) {
                return;
            }
            setTimeout(() => {
                var elementMove = [
                    // keyframes
                    {transform: "translateY(30px)", opacity: "0"},
                    {transform: "translateY(0px)", opacity: "1"},
                ];
                item.animate(elementMove, {
                    // timing options
                    duration: window.theme.animationDuration,
                    fill: "forwards",
                });
            }, window.theme.animationBetweenElements * i);
            item.setAttribute("data-loaded", true);
        });
    }

    elementFromRight(toReveal) {
        toReveal.forEach((item, i) => {
            if (item.getAttribute("data-loaded")) {
                return;
            }
            setTimeout(() => {
                var elementMove = [
                    // keyframes
                    {transform: "translateX(30px)", opacity: "0"},
                    {transform: "translateX(0px)", opacity: "1"},
                ];
                item.animate(elementMove, {
                    // timing options
                    duration: window.theme.animationDuration,
                    fill: "forwards",
                });
                item.setAttribute("data-loaded", true);
            }, window.theme.animationBetweenElements * i);
        });
    }

    elementFromLeft(toReveal) {
        toReveal.forEach((item, i) => {
            if (item.getAttribute("data-loaded")) {
                return;
            }
            setTimeout(() => {
                var elementMove = [
                    // keyframes
                    {transform: "translateX(-30px)", opacity: "0"},
                    {transform: "translateX(0px)", opacity: "1"},
                ];
                item.animate(elementMove, {
                    // timing options
                    duration: window.theme.animationDuration,
                    fill: "forwards",
                });
                item.setAttribute("data-loaded", true);
            }, window.theme.animationBetweenElements * i);
        });
    }

    elementFromRightBig(toReveal) {
        toReveal.forEach((item, i) => {
            if (item.getAttribute("data-loaded")) {
                return;
            }
            setTimeout(() => {
                var elementMove = [
                    // keyframes
                    {transform: "translateX(120px)", opacity: "0"},
                    {transform: "translateX(0px)", opacity: "1"},
                ];
                item.animate(elementMove, {
                    // timing options
                    duration: window.theme.animationDuration,
                    fill: "forwards",
                });
                item.setAttribute("data-loaded", true);
            }, window.theme.animationBetweenElements * i);
        });
    }

    elementFromLeftBig(toReveal) {
        toReveal.forEach((item, i) => {
            if (item.getAttribute("data-loaded")) {
                return;
            }
            setTimeout(() => {
                var elementMove = [
                    // keyframes
                    {transform: "translateX(-120px)", opacity: "0"},
                    {transform: "translateX(0px)", opacity: "1"},
                ];
                item.animate(elementMove, {
                    // timing options
                    duration: window.theme.animationDuration,
                    fill: "forwards",
                });
            }, window.theme.animationBetweenElements * i);
            item.setAttribute("data-loaded", true);
        });
    }

    setupAnimation(animatedItem, i) {
        var options = [],
            query = "";
        options["integer"] = i;
        options["type"] = animatedItem.getAttribute("data-animation");

        var _this = this;
        if (this.intersectionObserver[i]) {
            this.intersectionObserver[i].disconnect();
        }
        this.intersectionObserver[i] = new IntersectionObserver(
            this.reveal.bind(this, options),
            {
                threshold: 0.1,
            }
        );
        if (window.theme.enableImageAnimations) {
            query = ".animatedContent";
        }
        new DomHelper()
            .nodeListToArray(
                animatedItem.querySelectorAll(".animatedContent, .animatedContent")
            )
            .forEach(function (item) {
                _this.intersectionObserver[i].observe(item);
            });
    }

    reveal(a, results) {
        var _this = this;
        var integer = a["integer"];
        var toReveal = [];
        results.forEach(function (result) {
            if (result.isIntersecting || result.intersectionRatio > 0) {
                // isIntersecting does not exist on Samsung Android browser
                toReveal.push(result.target);
                _this.intersectionObserver[integer].unobserve(result.target);
            }
        });

        if (toReveal.length === 0) {
            return;
        }

        switch (a["type"]) {
            case "elementFromTop":
                this.elementFromTop(toReveal);
                break;

            case "elementFromBottom":
                this.elementFromBottom(toReveal);
                break;

            case "elementFromRight":
                this.elementFromRight(toReveal);
                break;

            case "elementFromLeft":
                this.elementFromLeft(toReveal);
                break;
            case "elementFromLeftBig":
                this.elementFromLeftBig(toReveal);
                break;
            case "elementFromRightBig":
                this.elementFromRightBig(toReveal);
                break;
            case "elementScaleIn":
                this.elementScaleIn(toReveal);
                break;
            case "elementScaleOut":
                this.elementScaleOut(toReveal);
        }
    }
}

class QuantityInput extends HTMLElement {
    constructor() {
        super();
        this.element = this;
        this.input = this.querySelector("input");
        this.changeEvent = new Event("quantity:changed", {bubbles: true});
        this.options = JSON.parse(this.element.getAttribute("data-settings"));

        this.querySelectorAll("button").forEach((button) =>
            button.addEventListener("click", this.onButtonClick.bind(this))
        );
    }

    onButtonClick(event) {
        event.preventDefault();
        const previousValue = this.input.value;

        event.target.name === "plus" ? this.input.stepUp() : this.input.stepDown();
        if (previousValue !== this.input.value)
            this.input.dispatchEvent(this.changeEvent);

        if (this.options["noVariants"] == "true") {
            this.toggleAddButton();
        }
    }

    toggleAddButton() {
        // Query the DOM for required elements
        const freeShipping = document.querySelector(".productElement--USPFirst");
        const addButton = document.querySelector(".ProductPage--ATC");
        const addButtonInner = addButton.querySelector(".SelfAlign");
        const quantityEl = document.querySelector('[name="quantity"]:checked');

        // Return early if the subscription toggle is selected
        if (document.querySelector('.subscriptionToggle--Subscribe').getAttribute('aria-selected') == "true") {
            return;
        }

        // Determine the selected quantity
        let quantity = quantityEl ? quantityEl.value : 1;

        // Replace the SVG with a placeholder
        const buySvgPlaceholder = `<svg
    class="mr-sl"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M14.7022 2.83115C14.6185 2.72792 14.4929 2.66759 14.36 2.66671H5.10669L5.39557 3.5556H13.7778L12.5911 8.88893H5.92446L3.89335 2.45782C3.84876 2.31931 3.73919 2.2114 3.60002 2.16893L1.7778 1.60893C1.62536 1.56209 1.45952 1.60013 1.34274 1.70872C1.22595 1.81731 1.17597 1.97996 1.21163 2.13539C1.24728 2.29082 1.36314 2.41542 1.51557 2.46227L3.11113 2.95115L5.15113 9.3956L4.42224 9.99116L4.36446 10.0489C3.99255 10.4775 3.97762 11.1099 4.32891 11.5556C4.57455 11.8543 4.94708 12.0192 5.33335 12H12.7511C12.9966 12 13.1956 11.8011 13.1956 11.5556C13.1956 11.3101 12.9966 11.1112 12.7511 11.1112H5.26224C5.15815 11.1076 5.06348 11.0499 5.01259 10.959C4.96171 10.8682 4.96199 10.7573 5.01335 10.6667L6.08446 9.77782H12.9467C13.1585 9.783 13.3446 9.63789 13.3911 9.43115L14.8 3.20893C14.8274 3.07467 14.7913 2.93527 14.7022 2.83115ZM12 14.6667C12.5523 14.6667 13 14.219 13 13.6667C13 13.1144 12.5523 12.6667 12 12.6667C11.4477 12.6667 11 13.1144 11 13.6667C11 14.219 11.4477 14.6667 12 14.6667ZM6.92445 13.6667C6.92445 14.219 6.47674 14.6667 5.92445 14.6667C5.37217 14.6667 4.92445 14.219 4.92445 13.6667C4.92445 13.1144 5.37217 12.6667 5.92445 12.6667C6.47674 12.6667 6.92445 13.1144 6.92445 13.6667Z"
      fill="#000B14" />
  </svg>
`;

        // Early exit if addButton is not found
        if (!addButton) return;

        // Handle unavailable variant
        if (this.currentVariant && this.currentVariant.available == false) {
            addButton.setAttribute("disabled", "disabled");
            addButton.classList.add("ProductCard--Sold__Out");
            addButtonInner.classList.add("u-p3");
            addButtonInner.innerHTML = buySvgPlaceholder + window.variantStrings.soldOut;
        } else {
            // Handle available variant
            addButton.removeAttribute("disabled");
            addButton.classList.remove("ProductCard--Sold__Out");

            // Show price if applicable
            let priceElement = "";
            if (window.variantInfo.show_price) {
                priceElement = "<span class='u-p3 ml-s'>" + Shopify.formatMoney(this.currentVariant.price * quantity, window.theme.moneyFormat) + "</span>";
            }

            addButtonInner.innerHTML = buySvgPlaceholder + window.variantStrings.addToCart + priceElement;
        }

        // Update free shipping information based on the threshold
        if (freeShipping) {
            const treshold = freeShipping.dataset.treshold;
            if (this.currentVariant.price * quantity >= treshold) {
                freeShipping.setAttribute("aria-hidden", false);
            } else {
                freeShipping.setAttribute("aria-hidden", true);
            }
        }
    }
}

customElements.define("quantity-input", QuantityInput);

function debounce(fn, wait) {
    let t;
    return (...args) => {
        clearTimeout(t);
        t = setTimeout(() => fn.apply(this, args), wait);
    };
}

const serializeForm = (form) => {
    const obj = {};
    const formData = new FormData(form);
    for (const key of formData.keys()) {
        obj[key] = formData.get(key);
    }
    return JSON.stringify(obj);
};

function fetchConfig(type = "json") {
    return {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            Accept: `application/${type}`,
        },
    };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == "undefined") {
    window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
    return function () {
        return fn.apply(scope, arguments);
    };
};

Shopify.setSelectorByValue = function (selector, value) {
    for (var i = 0, count = selector.options.length; i < count; i++) {
        var option = selector.options[i];
        if (value == option.value || value == option.innerHTML) {
            selector.selectedIndex = i;
            return i;
        }
    }
};

Shopify.addListener = function (target, eventName, callback) {
    target.addEventListener
        ? target.addEventListener(eventName, callback, false)
        : target.attachEvent("on" + eventName, callback);
};

Shopify.postLink = function (path, options) {
    options = options || {};
    var method = options["method"] || "post";
    var params = options["parameters"] || {};

    var form = document.createElement("form");
    form.setAttribute("method", method);
    form.setAttribute("action", path);

    for (var key in params) {
        var hiddenField = document.createElement("input");
        hiddenField.setAttribute("type", "hidden");
        hiddenField.setAttribute("name", key);
        hiddenField.setAttribute("value", params[key]);
        form.appendChild(hiddenField);
    }
    document.body.appendChild(form);
    form.submit();
    document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (
    country_domid,
    province_domid,
    options
) {
    this.countryEl = document.getElementById(country_domid);
    this.provinceEl = document.getElementById(province_domid);
    this.provinceContainer = document.getElementById(
        options["hideElement"] || province_domid
    );

    Shopify.addListener(
        this.countryEl,
        "change",
        Shopify.bind(this.countryHandler, this)
    );

    this.initCountry();
    this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
    initCountry: function () {
        var value = this.countryEl.getAttribute("data-default");
        Shopify.setSelectorByValue(this.countryEl, value);
        this.countryHandler();
    },

    initProvince: function () {
        var value = this.provinceEl.getAttribute("data-default");
        if (value && this.provinceEl.options.length > 0) {
            Shopify.setSelectorByValue(this.provinceEl, value);
        }
    },

    countryHandler: function (e) {
        var opt = this.countryEl.options[this.countryEl.selectedIndex];
        var raw = opt.getAttribute("data-provinces");
        var provinces = JSON.parse(raw);

        this.clearOptions(this.provinceEl);
        if (provinces && provinces.length == 0) {
            this.provinceContainer.style.display = "none";
        } else {
            for (var i = 0; i < provinces.length; i++) {
                var opt = document.createElement("option");
                opt.value = provinces[i][0];
                opt.innerHTML = provinces[i][1];
                this.provinceEl.appendChild(opt);
            }

            this.provinceContainer.style.display = "";
        }
    },

    clearOptions: function (selector) {
        while (selector.firstChild) {
            selector.removeChild(selector.firstChild);
        }
    },

    setOptions: function (selector, values) {
        for (var i = 0, count = values.length; i < values.length; i++) {
            var opt = document.createElement("option");
            opt.value = values[i];
            opt.innerHTML = values[i];
            selector.appendChild(opt);
        }
    },
};

class ProductForm extends HTMLElement {
    constructor() {
        super();
        new AddToCart(this);
    }
}

customElements.define("product-form", ProductForm);

class Countdown extends HTMLElement {
    constructor() {
        super();
        this.element = this;
        this.counter = 0;
        this.counter = this.element.querySelector(".counter");
        this.options = JSON.parse(this.element.getAttribute("data-settings"));
        const countInterval = setInterval(this.countDown.bind(this), 1000);
    }

    countDown() {
        const dateNow = new Date();
        const countDate = new Date(
            "March 3, 2030," + this.options["countdownTime"]
        );
        const nOfDays = this.options["countdownDays"];
        const difference = countDate - dateNow;

        var textDays = 0;
        const seconds = 1000;
        const minutes = seconds * 60;
        const hours = minutes * 60;
        const days = hours * 24;
        const todaysDay = dateNow.getDay();

        const textHours = Math.floor((difference % days) / hours);
        const textMinutes = Math.floor((difference % hours) / minutes);
        const textSeconds = Math.floor((difference % minutes) / seconds);

        if (todaysDay == 1) {
            textDays = nOfDays;
        } else if (todaysDay == 0) {
            textDays = 0;
        } else {
            textDays = nOfDays - todaysDay;
            if (textDays < 0) {
                const mDays = todaysDay % nOfDays;
                textDays = nOfDays - mDays;
            }
        }

        if (this.options["excludeWeekends"] && todaysDay == 5) {
            textDays = textDays + 2;
        } else if (this.options["excludeWeekends"] && todaysDay == 6) {
            textDays = textDays + 1;
        }

        const displayHours = textHours;
        const formatHours = displayHours < 10 ? `0${displayHours}` : displayHours;
        const formatMinutes = textMinutes < 10 ? `0${textMinutes}` : textMinutes;
        const formatSeconds = textSeconds < 10 ? `0${textSeconds}` : textSeconds;
        if (textDays > 0 && nOfDays > 1) {
            this.counter.innerText = `${textDays}d ${formatHours}:${formatMinutes}:${formatSeconds}`;
        } else {
            this.counter.innerText = `${formatHours}:${formatMinutes}:${formatSeconds}`;
        }
    }
}

customElements.define("countdown-element", Countdown);

class CartDrawer extends HTMLElement {
    constructor() {
        super();
        this.element = this;
        this.delegateElement = new Delegate(this.element);
        this.sidebarDrawer = new Drawer(this.element);
        this.loader = this.element.querySelector(".itemLoader");
        this.cartCount = document.querySelector(".CartCount");
        this.options = JSON.parse(this.element.getAttribute("data-settings"));
        this.pageLoader = document.body.querySelector(".pageLoader");
        this.breakpoint = new Responsive().getCurrentBreakpoint();
        new AddToCart(this.element);
        if (window.theme.enableImageAnimations) {
            new RevolutionAnimation(this.element);
        }
        this.bindEvents();
        if (window.location.href.indexOf("cartdrawer=true") > -1) {
            let r = new URL(location.href);
            r.searchParams.delete('cartdrawer');
            const newUrl = r.toString();
            window.history.pushState({path: newUrl}, '', newUrl);
            document.querySelector('[data-toggle-id="cart"]').click();
        }
        this.handleDiscountSetup();
    }

    onUnload() {
        this.delegateElement.off();
        document.removeEventListener("product:added", this.onProductAddedListener);
    }

    bindEvents() {
        if (window.theme.listener == "false") {
            this.onProductAddedListener = this.onProductAdded.bind(this);
            document.addEventListener("cart-drawer:open", this.onOpen.bind(this));
            document.addEventListener("product:added", this.onProductAddedListener);
            this.delegateElement.on(
                "click",
                '[data-action="update-item-quantity"], [data-action="remove-item"]',
                this.updateItemQuantity.bind(this)
            );
            this.delegateElement.on(
                "change",
                '[data-action="update-change-quantity"]',
                this.updateItemQuantity.bind(this)
            );
            this.delegateElement.on(
                "quantity:changed",
                ".QuantitySelector__CurrentQuantity",
                this.updateItemQuantity.bind(this)
            );

            this.delegateElement.on('click', '.cart--checkoutBtn', this.updateCartAttributes.bind(this));
            document.addEventListener('ocuNativeClick', this.updateCartAttributes.bind(this));
            window.theme.listener = "true";
        }
    }

    onOpen() {
        if (this.element.getAttribute("aria-expanded") == "false") {
            document.documentElement.style.setProperty(
                "--cartHeader-height",
                document.querySelector(".CartHeader").offsetHeight + "px"
            );

            if (this.options["showRecommendations"]) {
                this.loadRecommendations();
            }

        }
    }

    updateItemQuantity(event, target) {
        event.preventDefault();
        const item = target.closest('.cartItem');
        item.querySelector(".itemLoader")
            .classList.add("is-visible");
        var _this = this;

        var quantity = null;
        if (target.tagName === "INPUT") {
            quantity = parseInt(Math.max(parseInt(target.value) || 0, 0));
        } else {
            quantity = parseInt(target.getAttribute("data-quantity"));
        }


        if (item.querySelector('.bundleDiscount') && target.dataset.step == 'plus') {
            const items = [];
            items.push({
                id: item.dataset.variant,
                quantity: 1,
            });
            fetch(window.routes.localeRootUrl + "/cart/add.js", {
                body: JSON.stringify({
                    items: items,
                }),
                credentials: "same-origin",
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "X-Requested-With": "XMLHttpRequest",
                },
            }).then(function (response) {

                _this.renderCart();

            });
        } else if (item.querySelector('.bundleDiscount') && target.dataset.step == 'minus') {

            const bundleName = item.querySelector('.bundleDiscount').dataset.bundlename;

            const allBundleItems = this.element.querySelectorAll(`[data-bundlename=${bundleName}]`);

            let items = {
                'updates': {}
            };

            allBundleItems.forEach((subitem) => {

                items['updates'][`${subitem.closest('.cartItem').getAttribute("data-key").toString()}`] = 0;
            })

            fetch(window.routes.localeRootUrl + "/cart/update.js", {
                body: JSON.stringify(
                    items
                ),
                credentials: "same-origin",
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "X-Requested-With": "XMLHttpRequest",
                },
            }).then(function (response) {
                _this.renderCart();

            });
        } else {
            fetch(window.routes.localeRootUrl + "/cart/change.js", {
                body: JSON.stringify({
                    id: target.getAttribute("data-line-id"),
                    quantity: quantity,
                }),
                credentials: "same-origin",
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "X-Requested-With": "XMLHttpRequest",
                },
            }).then(function () {
                _this.renderCart(target.getAttribute("data-variant"), true);

            });
        }


    }

    handleDiscountSetup() {
        // Check if window.discounts is properly set and not empty
        if (!window.discounts || !Array.isArray(window.discounts) || window.discounts.length === 0) {
            console.error('Error: window.discounts is not set or is empty.');
            return;
        }

        this.productDiscounts = window.discounts;

        // Select all subscription items in the cart
        const allSubscriptionItems = this.element.querySelectorAll('.cartItem');

        // Initialize an array to store discount codes
        const discountArray = [];

        // Iterate through each subscription item
        allSubscriptionItems.forEach((item) => {

            let productQuantity = 0;
            const productId = item.dataset.id;
            if (item.dataset.bundle == 'false') {
                productQuantity = item.querySelector('.QuantitySelector__CurrentQuantity').value;
            }


            // Check if product ID and product quantity are valid
            if (!productId) {
                return;
            }

            // Find the matching discount from the productDiscounts array
            const matchedDiscount = this.productDiscounts.find(discount => {
                const itemId = discount.product.replace('gid://shopify/Product/', '');
                return productId === itemId;
            });

            // Initialize an array to store discount codes, discount values, and quantity of items
            let discountCode = [];
            let discountValue = [];
            let quantityOfItems = [];
            let discountValueFinal = 0;

            if (matchedDiscount) {
                if (item.hasAttribute('data-subscription')) {
                    discountCode = matchedDiscount.subscription_discount_code;
                    discountValue = matchedDiscount.discount_value;
                    quantityOfItems = matchedDiscount.quantity_of_items;
                } else {
                    discountCode = matchedDiscount.one_time_discount_code;
                    discountValue = matchedDiscount.one_discount_value;
                    quantityOfItems = matchedDiscount.one_time_quantity_of_items;
                }

                let finalDiscountValue = 0;

                // Find the index of the product quantity in the matched discount's quantity_of_items array
                if (discountCode && discountValue && quantityOfItems) {


                    const discountIndex = quantityOfItems.findIndex(quantity => quantity == productQuantity);

                    // If discountIndex is not found, check if the productQuantity is greater than the maximum quantity in the array

                    if (discountIndex === -1) {
                        const maxQuantity = Math.max(...quantityOfItems);
                        if (productQuantity > maxQuantity) {
                            discountArray.push(discountCode[discountCode.length - 1]);
                            discountValueFinal = discountValue[discountValue.length - 1];

                        } else {
                            discountValueFinal = 0;
                        }
                    } else {
                        // If discountIndex is found, add the corresponding discount code to the discountArray
                        discountArray.push(discountCode[discountIndex]);
                        discountValueFinal = discountValue[discountIndex];

                    }
                }


                // Fetch full price attribute from the item
                const priceItem = parseFloat(item.dataset.price);
                const itemID = item.getAttribute('id');

                if (discountValueFinal == 0 && item.querySelector('.bundleDiscount')) {
                    discountValueFinal = parseInt(item.querySelector('.bundleDiscount').dataset.bundle);
                    discountArray.push(item.querySelector('.bundleDiscount').dataset.bundlenamefull);
                }


                // this.subscriptionCartLinePrices(discountValueFinal, priceItem, itemID);

            }
        });

        const sessionArray = [...new Set(discountArray)];
        sessionStorage.setItem('discountArray', sessionArray);
        // this.subscriptionCartTotalPrices(discountArray);

    }

    subscriptionCartLinePrices(discountValue, priceItem, itemID) {

        // Calculate discounted price and format it
        const discountedPrice = priceItem * (1 - discountValue / 100);
        const formattedDiscountedPrice = Shopify.formatMoney(discountedPrice, window.theme.moneyFormat);
        const formattedBeforePrice = Shopify.formatMoney(priceItem, window.theme.moneyFormat);

        // Create a new <dd> element and set its innerHTML
        const dd = document.createElement('dd');
        dd.classList.add('order-discount-dd');
        dd.innerHTML = `<span class="order-discount ProductInfo--CompareAtPrice u-s4 mt-xs test234">${formattedBeforePrice}</span>`;

        // Find the target elements on the page
        const itemElement = this.element.querySelector(`#${itemID}`);
        const flexElement = itemElement.querySelector('.cart_item_price_flex_row .flex');
        const finalPriceElement = itemElement.querySelector('.ProductInfo--FinalPrice');

        // Check if target elements exist

        if (!itemElement || !flexElement || !finalPriceElement) {

            return;
        }

        // Remove any existing <dd> elements with the custom class
        const existingDd = flexElement.querySelector('.order-discount-dd');
        if (existingDd) {
            flexElement.removeChild(existingDd);
        }

        // Set 'data-lineprice' attribute, append <dd> element, and update the final price

        if (priceItem == discountedPrice) {
            return;
        }

        itemElement.setAttribute('data-lineprice', discountedPrice);
        flexElement.appendChild(dd);
        finalPriceElement.innerHTML = formattedDiscountedPrice;
    }

    subscriptionCartTotalPrices(discountArray) {

        // Find all cart items
        const allCartItems = this.element.querySelectorAll('.cartItem');
        // Check if cart items exist
        if (!allCartItems || allCartItems.length === 0) {

            return;
        }

        // Get cart total price from the dataset
        const cartTotalPrice = parseFloat(this.element.dataset.total);

        // Initialize totalPrice and iterate through all cart items to calculate the total price
        let totalPrice = 0;
        let totalCartPrice = 0;
        allCartItems.forEach((item) => {
            const linePrice = parseFloat(item.dataset.lineprice);
            const linePriceBefore = parseFloat(item.dataset.price);
            if (linePrice) {
                totalPrice += linePrice;
            }
            if (linePriceBefore) {
                totalCartPrice += linePriceBefore;
            }
        });

        const shippingTresholdElement = this.element.querySelector('.cartDrawer--freeShipping');
        if (shippingTresholdElement) {
            const shippingText = shippingTresholdElement.querySelector('.freeShipping-leftString');
            const shippingTreshold = shippingTresholdElement.dataset.shipping;
            const shippingDifference = shippingTreshold - totalPrice;
            if (shippingDifference > 0) {
                const formattedAmount = Shopify.formatMoney(shippingDifference, window.theme.moneyFormat);
                const freeShippingString = window.languages.free_shipping.replace('{{ amount }}', formattedAmount);
                shippingText.innerHTML = freeShippingString;
            } else {
                shippingText.innerHTML = window.languages.free_shipping_avaliable;
            }
        }

        this.element.querySelector('.totals__subtotal-value').innerHTML = Shopify.formatMoney(totalCartPrice, window.theme.moneyFormat);
        // Calculate the price difference
        this.priceDifference = cartTotalPrice - totalPrice;
        const displayPriceDifference = totalCartPrice - totalPrice;


        if (displayPriceDifference > 0) {
            // Format the difference price
            const formattedDifferencePrice = Shopify.formatMoney(displayPriceDifference, window.theme.moneyFormat);

            // Create the discountElement and set its class and innerHTML
            const discountElement = document.createElement('div');
            discountElement.classList.add('CartFooter--Total');

            discountElement.classList.add('CartFooter--TotalDiscounts');
            discountElement.classList.add('mb-sl');
            discountElement.innerHTML = `<h3 class="u-s5">${window.languages.discount_simple}</h3><ul class="discounts" role="list"><li class="orderDiscounts u-s5">${formattedDifferencePrice}</li></ul>`;

            if (!this.element.querySelector('.CartFooter--TotalPrice')) {

                return;
            }

            this.element.querySelector('.CartFooter--TotalPrice').innerHTML = Shopify.formatMoney(totalPrice, window.theme.moneyFormat);

            if (discountArray.length == 0) return;
            this.discountArray = [...new Set(discountArray)];

            // Find the CartFooter--TotalProducts element
            const totalProductsElement = this.element.querySelector('.CartFooter--TotalProducts');

            // Check if totalProductsElement exists
            if (!totalProductsElement) {
                return;
            }

            if (this.element.querySelector('.orderDiscounts')) {
                this.element.querySelector('.orderDiscounts').innerHTML = formattedDifferencePrice;
            } else {
                // Append the discountElement after the CartFooter--TotalProducts element

                totalProductsElement.parentNode.insertBefore(discountElement, totalProductsElement.nextSibling);
            }

        } else {

            if (this.element.querySelector('.CartFooter--TotalDiscounts')) {
                this.element.querySelector('.CartFooter--TotalDiscounts').remove();
            }
            if (discountArray.length == 0) return;
            this.discountArray = [...new Set(discountArray)];
        }

    }

    updateCartAttributes(event) {
        let myEvent = false;
        if (event) {
            event.preventDefault();
            myEvent = true;
        }
        const cartTotalPrice = parseFloat(this.element.dataset.total);
        // Find all cart items
        const allCartItems = this.element.querySelectorAll('.cartItem');
        // Check if cart items exist
        if (!allCartItems || allCartItems.length === 0) {

            return;
        }
        // Initialize totalPrice and iterate through all cart items to calculate the total price
        let totalPrice = 0;
        let totalCartPrice = 0;
        allCartItems.forEach((item) => {
            const linePrice = parseFloat(item.dataset.lineprice);
            const linePriceBefore = parseFloat(item.dataset.price);
            if (linePrice) {
                totalPrice += linePrice;
            }
            if (linePriceBefore) {
                totalCartPrice += linePriceBefore;
            }
        });

        this.priceDifference = cartTotalPrice - totalPrice;

        if (this.discountArray && this.discountArray.length && Array.isArray(this.discountArray)) {
            this.discountArray = this.discountArray.join(',');
        }

        if (!this.discountArray) {
            this.discountArray = sessionStorage.getItem('discountArray');
        }
        fetch(window.routes.localeRootUrl + "/cart/update.js", {
            body: JSON.stringify({
                attributes: {
                    "fixed-order-discount": this.priceDifference,
                    "order-bundles": this.discountArray
                }
            }),
            credentials: "same-origin",
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "X-Requested-With": "XMLHttpRequest",
            },
        }).then(function (response) {
            if (myEvent) {
                location.href = "/checkout";
            }


        });


    }

    onProductAdded() {
        var _this = this;
        this.renderCart().then(function () {
            _this.sidebarDrawer.openDrawer();
        });
    }

    renderCart(lineNumber, quantityChange) {
        this.pageLoader.style.width = 100 + "%";

        var _this = this;
        return fetch(window.routes.localeRootUrl + "/?section_id=cart-drawer", {
            credentials: "same-origin",
            method: "GET",
        }).then(function (content) {
            content.text().then(function (html) {
                _this.replaceContent(html, lineNumber, quantityChange);
            });
        });
    }

    replaceContent(html, lineNumber, quantityChange) {

        var _this = this;
        this.pageLoader.style.left = "unset";
        this.pageLoader.style.right = 0 + "px";
        this.pageLoader.style.width = 0 + "%";
        setTimeout(() => {
            this.pageLoader.style.left = 0 + "px";
            this.pageLoader.style.right = "unset";
        }, 550);
        var tempElement = document.createElement("div");
        tempElement.innerHTML = html;
        this.tempOptions = JSON.parse(
            tempElement.querySelector("#cart").getAttribute("data-settings")
        );
        const tempPrice = tempElement.querySelector('cart-drawer').dataset.total;
        this.element.dataset.total = tempPrice;

        var number = this.tempOptions["itemCount"];
        this.cartCount.innerHTML = "(" + number + ")";
        if (number > 0) {
            document.querySelector(".fullCart").style.display = "block";
            document.querySelector(".emptyCart").style.display = "none";
        } else {
            document.querySelector(".fullCart").style.display = "none";
            document.querySelector(".emptyCart").style.display = "block";
        }
        window.theme.cartCount = parseInt(number);

        if (lineNumber) {
            var cartNodeParent = this.element.querySelector(`[data-variant=${lineNumber}]`);
            const itemToReplaceWith = tempElement.querySelector(`[data-variant=${lineNumber}]`)

            if (cartNodeParent.querySelector(".itemLoader")) {
                cartNodeParent
                    .querySelector(".itemLoader")
                    .classList.remove("is-visible");
            }

            if (tempElement.querySelector(`#${lineNumber}`)) {
                cartNodeParent.setAttribute('data-lineprice', tempElement.querySelector(`#${lineNumber}`).dataset.lineprice);
            }

            if (tempElement.querySelector(`#${lineNumber}`)) {
                cartNodeParent.setAttribute('data-price', tempElement.querySelector(`#${lineNumber}`).dataset.price);
            }


            if (itemToReplaceWith) {
                cartNodeParent.replaceChild(
                    itemToReplaceWith,
                    cartNodeParent.querySelector(".cartItem--Informations")
                );
                _this.handleDiscountSetup();
            } else {
                cartNodeParent.classList.add("removing");
                cartNodeParent.animate(
                    [
                        // keyframes
                        {transform: "translateY(0px)", opacity: "1"},
                        {transform: "translateY(30px)", opacity: "0"},
                    ],
                    {
                        // timing options
                        duration: 500,
                        fill: "forwards",
                    }
                );
                setTimeout(() => {
                    cartNodeParent.remove();
                }, 500);

                if (this.options["showRecommendations"]) {
                    this.loadRecommendations();
                }
            }

            if (number > 0) {
                const checkoutButtonParent = this.element.querySelector(
                    ".CartDrawer--Footer"
                );
                const checkoutButtonToReplace = tempElement.querySelector(
                    ".MetaIcon--Wrappers"
                );
                if (checkoutButtonParent) {
                    checkoutButtonParent.replaceChild(
                        checkoutButtonToReplace,
                        checkoutButtonParent.querySelector(".MetaIcon--Wrappers")
                    );
                }

                const changeTotals = tempElement.querySelector(
                    ".CartFooter--Totals"
                );
                if (checkoutButtonParent && changeTotals) {
                    checkoutButtonParent.replaceChild(
                        changeTotals,
                        checkoutButtonParent.querySelector(".CartFooter--Totals")
                    );
                }

            } else {
                this.element
                    .querySelector(".CartDrawer--Footer")
                    .classList.add("removing");

                const mainPartParent = this.element.querySelector(".CartDrawer");

                mainPartParent.innerHTML =
                    tempElement.querySelector(".CartDrawer").innerHTML;

                if (window.theme.enableImageAnimations) {
                    const mainPartchildren =
                        mainPartParent.querySelector("#main-cartItems");
                    mainPartchildren.animate(
                        [
                            // keyframes
                            {opacity: "0"},
                            {opacity: "1"},
                        ],
                        {
                            // timing options
                            duration: 500,
                            fill: "forwards",
                        }
                    );
                }
            }
            if (this.element.querySelector(".itemLoader")) {
                setTimeout(() => {
                    this.element
                        .querySelector(".itemLoader")
                        .classList.remove("is-visible");
                }, 250);
            }

        } else {
            const cartNodeParent =
                this.element.querySelector(".CartDrawer").parentNode;
            const currentScrollPosition =
                this.element.querySelector("#main-cartItems").scrollTop;

            cartNodeParent.replaceChild(
                tempElement.querySelector(".CartDrawer"),
                this.element.querySelector(".CartDrawer")
            );
            this.element.querySelector("#main-cartItems").scrollTop =
                currentScrollPosition;
            if (window.theme.enableImageAnimations) {
                new RevolutionAnimation(this.element);
            }
        }
        setTimeout(() => {
            if (this.options["showRecommendations"] && !quantityChange) {
                this.loadRecommendations();
            }
            var focus = _this.element.querySelector("[data-scrollable]");
            bodyScrollLock.disableBodyScroll(focus, bodyScrollLockOptions);
            _this.sidebarDrawer.maxHeight();
        }, 200);


    }

    loadRecommendations() {
        if (this.options["productId"] == "") {
            var url = "?section_id=cart-recommendations";
        } else {
            var url =
                window.routes.localeRootUrl +
                "/recommendations/products?section_id=cart-recommendations&product_id=" +
                this.options["productId"] +
                "&limit=10";
        }

        var _this = this;

        return fetch(url).then(function (response) {
            return response
                .text()
                .then(function (content) {
                    var container = document.createElement("div");
                    container.innerHTML = content;
                    var z = container.querySelector(".cartUpsell").innerHTML;

                    var x = _this.element.querySelector(".CartMobileRecommendations");
                    x.innerHTML = z;
                    var id = container.querySelector("section").dataset.sectionid;

                    const swiper = new Swiper(
                        ".CartMobileRecommendations .swiperUpsell",
                        {
                            // Default parameters
                            slidesPerView: 2,
                            spaceBetween: 16,
                            loop: false,
                            pagination: {
                                el: ".sidecart_pagination",
                                type: "progressbar",
                                clickable: true,
                            },

                            breakpoints: {
                                1025: {
                                    slidesPerView: 2.444,
                                    spaceBetween: 16,
                                    slidesOffsetAfter: 32,
                                    slidesOffsetBefore: 32,
                                    navigation: {
                                        nextEl: ".swiperNextCart ",
                                        prevEl: ".swiperPrevCart",
                                    },
                                },
                            },
                        }
                    );

                    _this.element.dispatchEvent(
                        new CustomEvent("favorites:toggle", {bubbles: true})
                    );

                    _this.element.querySelector(".cartRecommendations").style.display =
                        "block";
                    if (window.theme.enableImageAnimations) {
                        new RevolutionAnimation(_this.element);
                    }
                })
                .catch((e) => {
                    console.error(e);
                });
        });
    }
}

customElements.define("cart-drawer", CartDrawer);

class FeaturedCollectionSection extends HTMLElement {
    constructor() {
        super();
        var _this = this;
        this.element = this;
        this.domDelegate = new Delegate(this.element);
        this.carouselElement = this.element.querySelector(".swiper");
        this.carousel = new RevolutionSwiper(this.carouselElement);

        this.bindEvents();
        if (window.theme.enableImageAnimations) {
            new RevolutionAnimation(this.element);
        }
        new AddToCart(this.element);
    }

    bindEvents() {
        this.isPageLoaded =
            document.readyState === "complete" ||
            document.readyState === "loaded" ||
            document.readyState === "interactive";
        if (!this.isPageLoaded) {
            window.addEventListener("load", this.onPageLoaded.bind(this));
        } else {
            this.onPageLoaded();
        }
    }

    onPageLoaded() {
        const handleIntersection = (entries, observer) => {
            if (!entries[0].isIntersecting) return;
            observer.unobserve(this);
            this.carousel = new RevolutionSwiper(this.carouselElement);
        };
        new IntersectionObserver(handleIntersection.bind(this), {
            rootMargin: "-100px 0px 200px 0px",
        }).observe(this);
    }
}

customElements.define("featured-collection", FeaturedCollectionSection);

class SliderTextSection extends HTMLElement {
    constructor() {
        super();
        this.element = this;
        this.carouselElement = this.element.querySelector(".swiper");
        this.carousel = new RevolutionSwiper(this.carouselElement);
        if (window.theme.enableImageAnimations) {
            new RevolutionAnimation(this.element);
        }
    }
}

customElements.define("slider-text", SliderTextSection);

class Banner extends HTMLElement {
    constructor() {
        super();
        this.element = this;
        if (window.theme.enableImageAnimations) {
            new RevolutionAnimation(this.element);
        }
        this.pageOverlayElement = document.querySelector(".pageOverlay");
        this.carouselElement = this.element.querySelector("[data-swiper-settings]");
        this.delegateBody = new Delegate(document.body);
        this.options = JSON.parse(
            this.element.getAttribute("data-section-settings")
        );
        this.delegateElement = new Delegate(this.element);
        if (this.options["numberOfSlides"] > 1) {
            this.carousel = new RevolutionSwiper(this.carouselElement);
            const swiper = this.carousel.swiperElement;


            this.onImagesReady = this.createObserver.bind(this);
            this.element.addEventListener("swiper:slide-changed", this.onImagesReady);
            this.createObserver();
        } else {
            this.createObserver();
        }
    }

    createObserver() {
        this.observer = new IntersectionObserver(this.handleIntersect.bind(this), {
            threshold: 0.5,
        });

        const target = this.element;
        this.observer.observe(target);
    }

    handleIntersect(entries) {
        var _this = this;
        entries.forEach((entry) => {
            if (entry.intersectionRatio === 1 || entry.isIntersecting == true) {
                if (_this.options["numberOfSlides"] > 1) {
                    _this.changeImageQuality();
                } else {
                    _this.changeImageQuality(true);
                }
                _this.observer.unobserve(_this);
            }
        });
    }

    changeImageQuality(singleItem) {
        var breakpoint = new Responsive().getCurrentBreakpoint();

        if (singleItem == true) {
            var imageContainers = this.element.querySelectorAll(
                ".Banner__ImageContainer--Swap"
            );
        } else {
            var currentIndex = this.carousel.swiperElement.activeIndex;
            var domHelper = new DomHelper();
            var cellElement = this.carousel.swiperElement.slides[currentIndex];
            var imageContainers = domHelper.nodeListToArray(
                cellElement.querySelectorAll(".Banner__ImageContainer--Swap")
            );
        }
        if (imageContainers.length === 0) {
            return;
        }
        var imageToReveal = null;

        if (
            breakpoint === "pocket" ||
            breakpoint === "phone" ||
            breakpoint === "tablet"
        ) {
            imageToReveal = imageContainers[0].querySelector(".Banner__Image");
        } else {
            imageToReveal = imageContainers[1].querySelector(".Banner__Image");
        }
        if (
            imageToReveal &&
            imageToReveal.getAttribute("data-loaded-image") != true
        ) {
            const replaceUrl = imageToReveal
                .getAttribute("data-src")
                .replace("{width}x", "2600x");

            imageToReveal.src = replaceUrl;
            imageToReveal.setAttribute("data-loaded-image", "true");
        }
    }
}

customElements.define("banner-hero", Banner);

class Header extends HTMLElement {
    constructor() {
        super();
        this.element = this;
        this.delegateElement = new Delegate(this.element);
        this.delegateBody = new Delegate(document.body);
        this.options = JSON.parse(this.getAttribute("data-settings"));
        this.carousel = this.element.querySelectorAll(".MenuSlideshow");
        var selectBoxes = this.element.querySelectorAll(".RevolutionDropdown");
        if (selectBoxes.length > 0) {
            selectBoxes.forEach((item, i) => {
                new RevolutionSelectbox(item);
            });
        }

        this.domHelper = new DomHelper();

        if (this.options.sticky) {
            this.toggleSticky();
        }
        this.bindEvents();
        this.menuOverlapHandler();
    }

    menuOverlapHandler() {
        var currentClientWidth = Math.max(
            document.body.scrollWidth,
            document.documentElement.scrollWidth,
            document.body.offsetWidth,
            document.documentElement.offsetWidth,
            document.documentElement.clientWidth
        );

        var menuItems = this.element.querySelector(".Header--MenuItems"),
            overlapping = false,
            menuWrapper = this.element.querySelector(".HeaderWrapper"),
            allHeights = [],
            _this = this;
        /* if (menuItems) {
        //     var desiredHeight = _this.element.querySelectorAll(".mainLinks");
        //     desiredHeight.forEach((item) => {
        //         allHeights.push(item.offsetHeight);
        //     });
        //     var maxHeight = Math.max.apply(null, allHeights);
        //     var minHeight = Math.min.apply(null, allHeights);
        //     if (maxHeight > minHeight) {
        //         overlapping = true;
        //         if (
        //             window.theme.menuBreakpoint == 0 ||
        //             window.theme.menuBreakpoint == undefined
        //         ) {
        //             window.theme.menuBreakpoint = currentClientWidth;
        //         }
        //     }
         }*/
        if (currentClientWidth > window.theme.menuBreakpoint) {
            menuItems.classList.remove("mt-m");
            menuItems.classList.remove("mainMenu--Overlapping");
            menuWrapper.querySelector(".mainMenuItems").prepend(menuItems);
            window.theme.menuBreakpoint = 0;
        } else if (overlapping) {
            menuItems.classList.add("mt-m");
            menuItems.classList.add("mainMenu--Overlapping");
            menuItems.closest(".header").appendChild(menuItems);
        }
        document.documentElement.style.setProperty(
            "--header-height",
            _this.element.clientHeight + "px"
        );
        menuItems.style.opacity = 1;
    }

    toggleSticky() {
        this.element.parentElement.classList.add("Header--Sticky");
        this.element.parentElement.classList.remove("Header--Transparent");
    }

    bindEvents() {
        const _this = this;
        document.addEventListener("shopify:section:load", function () {
            _this.menuOverlapHandlerListener();
        });
        this.menuOverlapHandlerListener = this.menuOverlapHandler.bind(this);
        window.addEventListener("resize", this.menuOverlapHandlerListener);
        this.toggleColorListener = this.toggleColor.bind(this);

        window.addEventListener("scroll", this.toggleColorListener);
        this.delegateBody.on("menu:close", this.closeMenu.bind(this), true);

        this.delegateElement.on(
            "mouseenter",
            "[aria-hasMenu='true']",
            this.openMenu.bind(this),
            true
        );

        this.delegateElement.on(
            "focusin",
            "[aria-hasMenu='true']",
            this.openMenu.bind(this),
            true
        );

        this.delegateElement.on(
            "mouseleave",
            "[aria-submenu]",
            this.closeMenu.bind(this),
            true
        );

        this.delegateElement.on(
            "mouseenter",
            "[aria-singlemenu]",
            this.closeMenu.bind(this),
            true
        );

        this.delegateElement.on(
            "focusin",
            "[aria-singleMenu], .mainLinks",
            this.closeMenu.bind(this),
            true
        );
    }

    updateMenuPosition(target) {
        document.documentElement.style.setProperty(
            "--submenu-position",
            `${target.getBoundingClientRect().top + target.offsetHeight + 3}px`
        );
    }

    openMenu(event, target) {
        this.element.dispatchEvent(new CustomEvent("menu:open", {bubbles: true}));

        if (event.type === "mouseenter" && target !== event.target) {
            return;
        }
        this.updateMenuPosition(target);
        this.element.classList.remove("Header--Transparent");
        target.setAttribute("aria-expanded", "true");

        this.domHelper
            .getSiblings(target, '[aria-expanded="true"]')
            .forEach(function (item) {
                item.setAttribute("aria-expanded", "false");
            });
        bodyScrollLock.disableBodyScroll(
            this.element.querySelector("[data-scrollable]"),
            bodyScrollLockOptions
        );
    }

    closeMenu(event, target) {
        if (event.type === "mouseleave" && target !== event.target) {
            return;
        }
        if (this.options["transparent"]) {
            this.element.classList.add("Header--Transparent");
        }

        const allOpen = this.element.querySelectorAll('[aria-expanded="true"]');
        allOpen.forEach(function (item) {
            item.setAttribute("aria-expanded", "false");
        });
        this.toggleColor();
        bodyScrollLock.clearAllBodyScrollLocks();
    }

    toggleColor() {
        if (window.pageYOffset > 25) {
            this.element.classList.add("Header--Scrolled");
        } else {
            this.element.classList.remove("Header--Scrolled");
        }
        if (this.options.transparent) {
            if (window.pageYOffset > 25 && this.options.sticky) {
                this.element.classList.remove("Header--Transparent");
            } else {
                this.element.classList.add("Header--Transparent");
            }
        }
    }
}

customElements.define("header-component", Header);

class MainMenuDropdown extends HTMLElement {
    constructor() {
        super();
        this.element = this;
        this.SidebarMenu = new Drawer(this.element);
        this.dropdown = new Dropdown(this.element);
        this.carouselElement = this.element.querySelector(".MenuSlideshowMobile");

        this.bindEvents();
    }

    bindEvents() {
        document.addEventListener("sidebar-drawer:open", this.onDrawerListener);
    }
}

customElements.define("main-menu-dropdown", MainMenuDropdown);

class Transition {
    constructor() {
        this.pageOverlay = document.querySelector(".pageTransition");

        if (!this.isPageLoaded) {
            document.addEventListener(
                "DOMContentLoaded",
                this.onPageLoaded.bind(this)
            );
        } else {
            this.onPageLoaded();
        }
    }

    onPageLoaded() {
        this.isPageLoaded = true;
        if (this.pageOverlay && window.theme.showPageTransition) {
            this.pageOverlay.classList.add("pageTransitionAnimation");
        }
    }

    onPageUnload(event, target) {
        if (
            event.defaultPrevented ||
            event.ctrlKey ||
            event.metaKey ||
            !window.theme.showPageTransition ||
            !this.pageOverlay
        ) {
            return;
        }

        event.preventDefault(); // Prevent the click to happen

        if (this.pageOverlay) {
            var timeline = new TimelineLite({
                onComplete: function onComplete() {
                    window.location.href = target.href;
                },
            });

            timeline.fromTo(
                this.pageOverlay,
                0.25,
                {autoAlpha: 0, ease: Linear.easeNone},
                {autoAlpha: 1, ease: Linear.easeNone}
            );
        }
    }
}

var trans = new Transition();

class VideoComponent extends HTMLElement {
    constructor() {
        super();
        this.element = this;
        this.options = JSON.parse(
            this.element.getAttribute("data-section-settings")
        );
        this.trueObserver = false;
        if (this.options["using_fade"] == "fade") {
            if (
                this.element.dataset.position == 0 ||
                this.element
                    .closest(".swiper-slide")
                    .classList.contains("swiper-slide-active") ||
                this.element
                    .closest(".swiper-slide")
                    .classList.contains("swiper-slide-duplicate-active")
            ) {
                this.checkLoaded();
                this.bindEvents();
            } else {
                this.bindEvents();
            }
        } else {
            this.createObserver();
        }
    }

    bindEvents() {
        window.removeEventListener(
            "swiper:slide-changed",
            this.onSlideChangeListener
        );
        this.onSlideChangeListener = this.onSlideChange.bind(this);
        window.addEventListener("swiper:slide-changed", this.onSlideChangeListener);
    }

    checkLoaded() {
        var _this = this;
        if (typeof videojs !== "undefined") {
            this.videoPlayerInicialization();
        } else {
            setTimeout(function () {
                _this.checkLoaded();
            }, 100);
        }
    }

    onSlideChange(event) {
        this.elementPosition = parseInt(this.element.getAttribute("data-position"));
        if (event.detail.currentIndex == this.elementPosition) {
            if (!this.element.getAttribute("loaded")) {
                var node = document.createElement("div");
                node.appendChild(
                    this.element
                        .querySelector("template")
                        .content.firstElementChild.cloneNode(true)
                );
                this.element.appendChild(node.firstElementChild).focus();
                this.element.setAttribute("loaded", true);
                if (!this.videoPlayer) {
                    this.checkLoaded();
                } else {
                    if (this.options["viewport"]) {
                        this.videoPlayer.play();
                        this.createObserver();
                    }
                }
            } else {
                if (!this.videoPlayer) {
                    this.checkLoaded();
                } else {
                    if (this.options["viewport"]) {
                        this.videoPlayer.play();
                        this.createObserver();
                    }
                }
            }
        } else if (
            this.videoPlayer &&
            this.videoPlayer.el_.classList.contains("vjs-playing")
        ) {
            this.videoPlayer.pause();
        }
    }

    videoPlayerInicialization() {
        var _this = this;
        if (!this.element.getAttribute("loaded")) {
            var node = document.createElement("div");
            node.appendChild(
                this.element
                    .querySelector("template")
                    .content.firstElementChild.cloneNode(true)
            );
            this.element.appendChild(node.firstElementChild).focus();
            this.element.setAttribute("loaded", true);
        }
        let responsive = new Responsive();
        let breakpoint = responsive.getCurrentBreakpoint();
        if (breakpoint == "phone" || breakpoint == "tablet") {
            var isMobile = true;
        } else {
            var isMobile = false;
        }

        let img_plh = "",
            aspect_ratio = "",
            src = "",
            host = "html5",
            autoplay = this.options["viewport"];

        if (isMobile) {
            img_plh = this.options["plh_mob"];
            if (this.options["aspect_mob"]) {
                aspect_ratio = this.options["aspect_mob"];
            } else {
                aspect_ratio = "9:16";
            }
            if (this.options["control_var"]) {
                src = this.options["videom"];
            } else if (this.options["video_inside_media"]) {
                const sources = this.options["videod"]["sources"];
                let topQuality = null;
                sources.forEach((obj) => {
                    if (obj.format === "mp4") {
                        if (!topQuality) topQuality = obj;
                        if (topQuality.height < obj.height) topQuality = obj;
                    }
                });
                const aspectRatioHeight = Math.floor(
                    100 / this.options["videod"]["aspect_ratio"]
                );
                if (!this.options["videoRatio"]) {
                    aspect_ratio = `100:${aspectRatioHeight}`;
                }
                src = topQuality["url"] + "#t=0.001";
            } else {
                const aspectRatioHeight = Math.floor(
                    100 / this.options["videom"]["aspect_ratio"]
                );
                if (!this.options["videoRatio"]) {
                    aspect_ratio = `100:${aspectRatioHeight}`;
                }
                host = this.options["videom"]["host"];
                if (host == "youtube") {
                    src =
                        "https://www.youtube.com/watch?v=" +
                        this.options["videom"]["external_id"];
                } else {
                    src = this.options["videom"]["external_id"];
                }
                autoplay = false;
            }
        } else {
            img_plh = this.options["plh_desk"];
            if (this.options["aspect_desk"]) {
                aspect_ratio = this.options["aspect_desk"];
            } else {
                aspect_ratio = "16:9";
            }

            if (this.options["control_var"]) {
                src = this.options["videod"];
            } else if (this.options["video_inside_media"]) {
                const sources = this.options["videod"]["sources"];
                let topQuality = null;
                sources.forEach((obj) => {
                    if (obj.format === "mp4") {
                        if (!topQuality) topQuality = obj;
                        if (topQuality.height < obj.height) topQuality = obj;
                    }
                });
                src = topQuality["url"] + "#t=0.001";
                const aspectRatioHeight = Math.floor(
                    100 / this.options["videod"]["aspect_ratio"]
                );
                if (!this.options["videoRatio"]) {
                    aspect_ratio = `100:${aspectRatioHeight}`;
                }
            } else {
                host = this.options["videod"]["host"];
                const aspectRatioHeight = Math.floor(
                    100 / this.options["videod"]["aspect_ratio"]
                );
                if (!this.options["videoRatio"]) {
                    aspect_ratio = `100:${aspectRatioHeight}`;
                }
                if (host == "youtube") {
                    src =
                        "https://www.youtube.com/watch?v=" +
                        this.options["videod"]["external_id"];
                } else {
                    src = this.options["videod"]["external_id"];
                }
            }
        }
        if (host == "youtube") {
            var type = "video/youtube";
        } else if (host == "vimeo") {
            var type = "video/vimeo";
        } else {
            var type = "video/mp4";
        }

        if (!this.options["plh"]) {
            img_plh = false;
        }

        const payload = {
            aspectRatio: aspect_ratio,
            autoplay: autoplay,
            muted: this.options["muted"],
            loop: this.options["loop"],
            controls: this.options["controls"],
            poster: img_plh,
            preload: "metadata",
            playsinline: true,
            responsive: true,
            techOrder: [host],
            disablePictureInPicture: true,
            controlBar: {
                playToggle: true,
                captionsButton: false,
                chaptersButton: false,
                subtitlesButton: false,
                remainingTimeDisplay: true,
                pictureInPictureToggle: false,
                volumeControl: false,
                progressControl: {
                    seekBar: false,
                },
                fullscreenToggle: true,
                playbackRateMenuButton: false,
            },
            sources: [
                {
                    type: type,
                    src: src,
                },
            ],
        };

        var videoplayerID = this.element.querySelector("video");
        this.videoPlayer = videojs(videoplayerID, payload);
        this.videoPlayer.on("ready", function () {
            _this.element.querySelector(".videoHolder").style.display = "block";
            if (_this.trueObserver == false && _this.options["pause"]) {
                _this.createObserver();
            }
        });
        this.videoPlayer.on("touchstart", function () {
            if (!this.paused()) {
                this.pause();
            } else {
                this.play();
            }
        });
    }

    createObserver() {
        const observer = new IntersectionObserver(this.handleIntersect.bind(this), {
            threshold: 0.15,
        });

        const target = this.element;
        observer.observe(target);
        this.trueObserver = true;
    }

    handleIntersect(entries) {
        entries.forEach((entry) => {
            if (entry.intersectionRatio === 1 || entry.isIntersecting == true) {
                if (!this.videoPlayer) {
                    this.checkLoaded();
                    return;
                }

                if (this.options["viewport"] && this.videoPlayer) {
                    if (this.options["muted"]) {
                        this.videoPlayer.muted("true");
                    }
                    this.videoPlayer.play();
                }
            } else if (
                entry.intersectionRatio === 0 ||
                entry.isIntersecting == false
            ) {
                if (
                    this.videoPlayer &&
                    this.videoPlayer.el_.classList.contains("vjs-playing")
                ) {
                    this.videoPlayer.pause();
                }
            }
        });
    }
}

customElements.define("video-component", VideoComponent);

class FooterComponent extends HTMLElement {
    constructor() {
        super();
        this.element = this;
        let responsive = new Responsive();
        let breakpoint = responsive.getCurrentBreakpoint();
        if (breakpoint == "phone" || breakpoint == "tablet") {
            this.dropdown = new Dropdown(this.element);
        }

        this.delElem = new Delegate(this.element);
        this.bindEvents();
    }

    bindEvents() {
        this.delElem.on('click', '[data-action="new-tab"]', this.openInNewTab.bind(this));
    }

    openInNewTab() {
        event.preventDefault();

        const url = event.target.closest('[data-action="new-tab"]').href;
        if (url) {
            window.open(url, "_blank");
        }
    }
}

customElements.define("footer-component", FooterComponent);

class DropdownSection extends HTMLElement {
    constructor() {
        super();
        this.element = this;
        this.dropdown = new Dropdown(this.element);
    }
}

customElements.define("dropdown-section", DropdownSection);

class ProductElement extends HTMLElement {
    constructor() {
        super();

        this.element = this;
        this.domDelegate = new Delegate(this.element);
        this.bodyDelegate = new Delegate(this.element);
        this.carouselElement = this.element.querySelector(".mainSwiper");
        this.carouselElementThumbs = this.element.querySelector(
            ".ProductSlider--Thumbnails"
        );

        this.subscriptionOpen = false;
        this.options = JSON.parse(
            this.element.getAttribute("data-section-settings")
        );

        if (this.options["slides_number"] > 1) {
            if (this.options["show_thumbnails"]) {
                this.carousel = new RevolutionSwiper(
                    this.carouselElement,
                    this.carouselElementThumbs
                );
            } else {
                this.carousel = new RevolutionSwiper(this.carouselElement);
            }
        }

        this.changeImageQuality();
        this.valuesWrap = this.element.querySelectorAll(
            ".ProductOption--ValusWrapper"
        );
        var localPickup = this.element.querySelector("#LocalPickup");
        if (localPickup) {
            new Drawer(this.querySelector("#LocalPickup"));
        }
        new AddToCart(this.element);
        new Dropdown(this.element.querySelector(".ProductInfo--Wrapper"));

        if (window.theme.enableImageAnimations) {
            new RevolutionAnimation(this.element);
        }
        if (this.options["enable_zoom"]) {
            new RevolutionImageZoom(this.element, this.carousel);
        }

        var selectBoxes = this.element.querySelectorAll(".RevolutionDropdown");

        if (selectBoxes.length > 0) {
            selectBoxes.forEach((item, i) => {
                new RevolutionSelectbox(item);
            });
        }

        if (
            this.options["variant_image_id"] &&
            this.options["show_variant_image_on_load"]
        ) {
            this.updateImage();
        }
        this.handleSticky();
        this.bindEvents();
    }

    toggleAddButton() {
        // Query the DOM for required elements
        const freeShipping = document.querySelector(".productElement--USPFirst");
        const addButton = document.querySelector(".ProductPage--ATC");
        const addButtonInner = addButton.querySelector(".SelfAlign");
        const quantityEl = document.querySelector('[name="quantity"]:checked');

        // Return early if the subscription toggle is selected
        if (document.querySelector('.subscriptionToggle--Subscribe')?.getAttribute('aria-selected') == "true") {
            return;
        }

        // Determine the selected quantity
        let quantity = quantityEl ? quantityEl.value : 1;

        // Replace the SVG with a placeholder
        const buySvgPlaceholder = `<svg
            class="mr-sl"
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M14.7022 2.83115C14.6185 2.72792 14.4929 2.66759 14.36 2.66671H5.10669L5.39557 3.5556H13.7778L12.5911 8.88893H5.92446L3.89335 2.45782C3.84876 2.31931 3.73919 2.2114 3.60002 2.16893L1.7778 1.60893C1.62536 1.56209 1.45952 1.60013 1.34274 1.70872C1.22595 1.81731 1.17597 1.97996 1.21163 2.13539C1.24728 2.29082 1.36314 2.41542 1.51557 2.46227L3.11113 2.95115L5.15113 9.3956L4.42224 9.99116L4.36446 10.0489C3.99255 10.4775 3.97762 11.1099 4.32891 11.5556C4.57455 11.8543 4.94708 12.0192 5.33335 12H12.7511C12.9966 12 13.1956 11.8011 13.1956 11.5556C13.1956 11.3101 12.9966 11.1112 12.7511 11.1112H5.26224C5.15815 11.1076 5.06348 11.0499 5.01259 10.959C4.96171 10.8682 4.96199 10.7573 5.01335 10.6667L6.08446 9.77782H12.9467C13.1585 9.783 13.3446 9.63789 13.3911 9.43115L14.8 3.20893C14.8274 3.07467 14.7913 2.93527 14.7022 2.83115ZM12 14.6667C12.5523 14.6667 13 14.219 13 13.6667C13 13.1144 12.5523 12.6667 12 12.6667C11.4477 12.6667 11 13.1144 11 13.6667C11 14.219 11.4477 14.6667 12 14.6667ZM6.92445 13.6667C6.92445 14.219 6.47674 14.6667 5.92445 14.6667C5.37217 14.6667 4.92445 14.219 4.92445 13.6667C4.92445 13.1144 5.37217 12.6667 5.92445 12.6667C6.47674 12.6667 6.92445 13.1144 6.92445 13.6667Z"
              fill="#000B14" />
          </svg>
        `;

        // Early exit if addButton is not found
        if (!addButton) return;

        // Handle unavailable variant
        if (this.currentVariant?.available === false) {
            addButton.setAttribute("disabled", "disabled");
            addButton.classList.add("ProductCard--Sold__Out");
            addButtonInner.classList.add("u-p3");
            addButtonInner.innerHTML = buySvgPlaceholder + window.variantStrings.soldOut;
        } else {
            // Handle available variant
            addButton.removeAttribute("disabled");
            addButton.classList.remove("ProductCard--Sold__Out");

            // Show price if applicable
            let priceElement = "";
            if (window.variantInfo?.show_price) {
                priceElement = "<span class='u-p3 ml-s'>" + Shopify.formatMoney(this.currentVariant.price * quantity, window.theme.moneyFormat) + "</span>";
            }

            addButtonInner.innerHTML = buySvgPlaceholder + window.variantStrings.addToCart + priceElement;
        }

        // Update free shipping information based on the threshold
        if (freeShipping) {
            const treshold = freeShipping.dataset.treshold;
            if (this.currentVariant.price * quantity >= treshold) {
                freeShipping.setAttribute("aria-hidden", false);
            } else {
                freeShipping.setAttribute("aria-hidden", true);
            }
        }
    }

    bindEvents() {
        this.domDelegate.on("variant:changed", this.updateImage.bind(this));
        this.domDelegate.on(
            "click",
            '[data-action="toggle-subscription"]',
            this.toggleSubscription.bind(this)
        );
        this.domDelegate.on(
            "change",
            '[name="quantity"]',
            this.changeQuantity.bind(this)
        );
        this.domDelegate.on(
            "click",
            '[data-action="click-atc"]',
            this.toggleATC.bind(this)
        );

    }

    toggleATC() {
        this.element.querySelector(".ProductPage--ATC").click();
    }

    changeQuantity() {
        if (this.options["noVariants"] == "true") {
            this.toggleAddButton();
        } else {
            this.element.dispatchEvent(
                new CustomEvent("quantity:changed", {bubbles: true})
            );
        }
    }

    handleSticky() {
        const stickyATC = this.element.querySelector(".stickyATC");
        if (stickyATC) {
            const elementToObserve = this.element.querySelector(".ProductActions");
            const handleIntersection = (entries) => {
                if (entries[0].isIntersecting) {
                    stickyATC.setAttribute("aria-hidden", "true");
                } else {
                    stickyATC.setAttribute("aria-hidden", "false");
                }
            };
            new IntersectionObserver(handleIntersection.bind(this), {
                rootMargin: "0px",
            }).observe(elementToObserve);
        }
    }


    toggleSubscription() {
        // Query the DOM for required elements
        const oneTimeButton = this.element.querySelector(".subscriptionToggle--OneTime");
        const subscribeButton = this.element.querySelector(".subscriptionToggle--Subscribe");
        const subscriptionWrapper = this.element.querySelector(".subscriptionWrapper");
        const addToCartBtn = this.element.querySelector(".ProductPage--ATC .SelfAlign");

        if (!oneTimeButton || !subscribeButton || !subscriptionWrapper || !addToCartBtn) {
            return;
        }

        const buySvg = `<svg
            class="mr-sl"
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M14.7022 2.83115C14.6185 2.72792 14.4929 2.66759 14.36 2.66671H5.10669L5.39557 3.5556H13.7778L12.5911 8.88893H5.92446L3.89335 2.45782C3.84876 2.31931 3.73919 2.2114 3.60002 2.16893L1.7778 1.60893C1.62536 1.56209 1.45952 1.60013 1.34274 1.70872C1.22595 1.81731 1.17597 1.97996 1.21163 2.13539C1.24728 2.29082 1.36314 2.41542 1.51557 2.46227L3.11113 2.95115L5.15113 9.3956L4.42224 9.99116L4.36446 10.0489C3.99255 10.4775 3.97762 11.1099 4.32891 11.5556C4.57455 11.8543 4.94708 12.0192 5.33335 12H12.7511C12.9966 12 13.1956 11.8011 13.1956 11.5556C13.1956 11.3101 12.9966 11.1112 12.7511 11.1112H5.26224C5.15815 11.1076 5.06348 11.0499 5.01259 10.959C4.96171 10.8682 4.96199 10.7573 5.01335 10.6667L6.08446 9.77782H12.9467C13.1585 9.783 13.3446 9.63789 13.3911 9.43115L14.8 3.20893C14.8274 3.07467 14.7913 2.93527 14.7022 2.83115ZM12 14.6667C12.5523 14.6667 13 14.219 13 13.6667C13 13.1144 12.5523 12.6667 12 12.6667C11.4477 12.6667 11 13.1144 11 13.6667C11 14.219 11.4477 14.6667 12 14.6667ZM6.92445 13.6667C6.92445 14.219 6.47674 14.6667 5.92445 14.6667C5.37217 14.6667 4.92445 14.219 4.92445 13.6667C4.92445 13.1144 5.37217 12.6667 5.92445 12.6667C6.47674 12.6667 6.92445 13.1144 6.92445 13.6667Z"
              fill="#000B14" />
          </svg>
        `;

        // If subscription is open and the clicked button is not 'subscribe'
        if (this.subscriptionOpen && event.target.dataset.value != 'subscribe') {
            oneTimeButton.setAttribute("aria-selected", "true");
            subscribeButton.setAttribute("aria-selected", "false");
            subscriptionWrapper.setAttribute("aria-hidden", "true");

            this.element.querySelector("#selling_plan").value = "";
            addToCartBtn.innerHTML = buySvg + window.variantStrings.addToCart;

            this.subscriptionOpen = false;
            this.toggleQuantitySavings();
        }
        // If subscription is not open and the clicked button is not 'one_time'
        else if (!this.subscriptionOpen && event.target.dataset.value != 'one_time') {
            oneTimeButton.setAttribute("aria-selected", "false");
            subscribeButton.setAttribute("aria-selected", "true");
            subscriptionWrapper.setAttribute("aria-hidden", "false");

            this.element.querySelector("#selling_plan").value = subscribeButton.dataset.plan;
            addToCartBtn.innerHTML = window.variantStrings.start_subscription;

            this.subscriptionOpen = true;
            this.toggleQuantitySavings();
        }
    }


    toggleQuantitySavings() {

        const allLabels = this.element.querySelectorAll('label.quantityWrapper');
        allLabels.forEach((item) => {
            const quantityOption = JSON.parse(item.getAttribute("data-options"));
            let discountTogether = parseInt(quantityOption['discount']);
            if (this.subscriptionOpen == true) {
                discountTogether = parseInt(quantityOption['discount_code_perc']);

                if (this.element.querySelector(`#${item.getAttribute('for')}`).checked && document.querySelector('#cart_discount')) {
                    document.querySelector('#cart_discount').value = quantityOption['discount_code'];
                }

            }

            const price = item.querySelector('.quantityPrice'),
                quantityPriceSavings = item.querySelector('.quantityPriceSavings'),

                newPrice = (quantityOption['compare']) - (quantityOption['compare'] * discountTogether / 100),
                difference = quantityOption['compare'] - newPrice;


            price.innerHTML = Shopify.formatMoney(
                newPrice,
                window.theme.moneyFormat
            );


            if (difference > 0) {
                item.setAttribute('aria-hidden', 'false');
            } else {
                item.setAttribute('aria-hidden', 'true');
            }
            const formattedDifference = Shopify.formatMoney(difference, window.theme.moneyFormat);
            const newString = window.languages.discount.replace('{{ percentage }}', discountTogether);

            const finalNewString = newString.replace('(-{{amount}})', `(-${formattedDifference})`);
            if (quantityPriceSavings) {
                quantityPriceSavings.innerHTML = finalNewString;
            }


        })

    }

    updateImage(event) {
        if (event) {
            var imageID = event.detail.new_image;
        } else {
            var imageID = this.options["variant_image_id"];
        }

        var selector = "#Image--" + imageID;
        var imageEl = this.element.querySelector(selector);

        if (imageEl) {
            this.carousel.selectCell(parseInt(imageEl.getAttribute("data-position")));
        }
    }

    changeImageQuality() {
        var imageToReveal = null;
        imageToReveal = this.element.querySelector(".ProductSlider--ImageFirst");
        if (imageToReveal !== null) {
            const replaceUrl = imageToReveal
                .getAttribute("data-src")
                .replace("{width}x", "2600x");
            imageToReveal.src = replaceUrl;
        }
    }
}

customElements.define("product-component", ProductElement);

class VariantSelects extends HTMLElement {
    constructor() {
        super();
        this.element = this;
        this.type = this.element.getAttribute("data-type");
        this.productID = this.element.getAttribute("data-product-id");
        this.delegateElement = new Delegate(this.element);
        this.delegateBody = new Delegate(document.body);

        this.bindEvents();
    }

    bindEvents() {
        this.delegateBody.on("quantity:changed", this.onQuantityChange.bind(this));

        var selectboxes = this.element.querySelectorAll("select, input");
        selectboxes.forEach((item) => {
            item.addEventListener("change", this.onVariantChange.bind(this));
        });
    }

    onQuantityChange() {
        this.updateOptions();
        this.updateMasterId();
        this.toggleAddButton();
    }

    onVariantChange() {
        this.updateOptions();
        this.updateMasterId();
        this.toggleAddButton();
        this.updatePickupAvailability();

        this.updateMedia();
        this.updateURL();
        this.updateVariantInput();
        this.renderProductInfo();
    }

    updateOptions() {
        this.options = Array.from(
            this.querySelectorAll("select, input:checked"),
            (select) => select.value
        );
    }

    updateMasterId() {
        this.currentVariant = this.getVariantData().find((variant) => {
            this.options;
            return !variant.options
                .map((option, index) => {
                    return this.options[index] === option;
                })
                .includes(false);
        });
    }

    updateMedia() {
        if (!this.currentVariant) return;
        if (!this.currentVariant.featured_media) return;

        const newMedia = this.currentVariant.featured_media.id;
        if (!newMedia) return;
        this.element.dispatchEvent(
            new CustomEvent("variant:changed", {
                bubbles: true,
                detail: {new_image: newMedia},
            })
        );
    }

    updateURL() {
        if (!this.currentVariant) return;
        window.history.replaceState(
            {},
            "",
            `${this.dataset.url}?variant=${this.currentVariant.id}`
        );
    }

    updateVariantInput() {
        const productForms = document.querySelectorAll(
            `#product-form-${this.productID}, #product-form-installment`
        );

        productForms.forEach((productForm) => {
            const input = productForm.querySelector('input[name="id"]');
            input.value = this.currentVariant.id;
            input.dispatchEvent(new Event("change", {bubbles: true}));
        });
    }

    updatePickupAvailability() {
        const pickUpAvailability = document.querySelector("pickup-availability");
        if (!pickUpAvailability) return;

        if (this.currentVariant && this.currentVariant.available) {
            pickUpAvailability.fetchAvailability(this.currentVariant.id);
        } else {
            pickUpAvailability.removeAttribute("available");
            pickUpAvailability.innerHTML = "";
        }
    }

    renderProductInfo() {
        fetch(
            `${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`
        )
            .then((response) => response.text())
            .then((responseText) => {
                const id = ".ProductInfo--Prices";
                const html = new DOMParser().parseFromString(responseText, "text/html");
                const destinations = document.querySelectorAll(id);
                const source = html.querySelector(id);

                if (source && destinations) {
                    destinations.forEach((destination) => {
                        destination.innerHTML = source.innerHTML;
                    });
                }

                const quantityButton = document.querySelector(".QuantityHandler");
                if (quantityButton) {
                    const source = html.querySelector(".QuantityHandler");
                    if (source && quantityButton)
                        quantityButton.innerHTML = source.innerHTML;
                }
                this.toggleAddButton();
            });
    }

    toggleAddButton() {
        // Query the DOM for required elements
        const freeShipping = document.querySelector(".productElement--USPFirst");
        const addButton = document.querySelector(".ProductPage--ATC");
        const addButtonInner = addButton.querySelector(".SelfAlign");
        const quantityEl = document.querySelector('[name="quantity"]:checked');

        // Return early if the subscription toggle is selected

        // if (document.querySelector('.subscriptionToggle--Subscribe').getAttribute('aria-selected') == "true") {
        //     return;
        // }

        // Determine the selected quantity
        let quantity = quantityEl ? quantityEl.value : 1;

        // Replace the SVG with a placeholder
        const buySvgPlaceholder = `<svg
            class="mr-sl"
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M14.7022 2.83115C14.6185 2.72792 14.4929 2.66759 14.36 2.66671H5.10669L5.39557 3.5556H13.7778L12.5911 8.88893H5.92446L3.89335 2.45782C3.84876 2.31931 3.73919 2.2114 3.60002 2.16893L1.7778 1.60893C1.62536 1.56209 1.45952 1.60013 1.34274 1.70872C1.22595 1.81731 1.17597 1.97996 1.21163 2.13539C1.24728 2.29082 1.36314 2.41542 1.51557 2.46227L3.11113 2.95115L5.15113 9.3956L4.42224 9.99116L4.36446 10.0489C3.99255 10.4775 3.97762 11.1099 4.32891 11.5556C4.57455 11.8543 4.94708 12.0192 5.33335 12H12.7511C12.9966 12 13.1956 11.8011 13.1956 11.5556C13.1956 11.3101 12.9966 11.1112 12.7511 11.1112H5.26224C5.15815 11.1076 5.06348 11.0499 5.01259 10.959C4.96171 10.8682 4.96199 10.7573 5.01335 10.6667L6.08446 9.77782H12.9467C13.1585 9.783 13.3446 9.63789 13.3911 9.43115L14.8 3.20893C14.8274 3.07467 14.7913 2.93527 14.7022 2.83115ZM12 14.6667C12.5523 14.6667 13 14.219 13 13.6667C13 13.1144 12.5523 12.6667 12 12.6667C11.4477 12.6667 11 13.1144 11 13.6667C11 14.219 11.4477 14.6667 12 14.6667ZM6.92445 13.6667C6.92445 14.219 6.47674 14.6667 5.92445 14.6667C5.37217 14.6667 4.92445 14.219 4.92445 13.6667C4.92445 13.1144 5.37217 12.6667 5.92445 12.6667C6.47674 12.6667 6.92445 13.1144 6.92445 13.6667Z"
              fill="#000B14" />
          </svg>
        `;

        // Early exit if addButton is not found
        if (!addButton) return;

        // Handle unavailable variant
        if (this.currentVariant.available == false) {
            addButton.setAttribute("disabled", "disabled");
            addButton.classList.add("ProductCard--Sold__Out");
            addButtonInner.classList.add("u-p3");
            addButtonInner.innerHTML = buySvgPlaceholder + window.variantStrings.soldOut;
        } else {
            // Handle available variant
            addButton.removeAttribute("disabled");
            addButton.classList.remove("ProductCard--Sold__Out");

            // Show price if applicable
            let priceElement = "";
            console.log(window.variantInfo)
            if (window.variantInfo?.show_price) {
                priceElement = "<span class='u-p3 ml-s'>" + Shopify.formatMoney(this.currentVariant.price * quantity, window.theme.moneyFormat) + "</span>";
            }

            addButtonInner.innerHTML = buySvgPlaceholder + window.variantStrings.addToCart + priceElement;
        }

        // Update free shipping information based on the threshold
        if (freeShipping) {
            const treshold = freeShipping.dataset.treshold;
            if (this.currentVariant.price * quantity >= treshold) {
                freeShipping.setAttribute("aria-hidden", false);
            } else {
                freeShipping.setAttribute("aria-hidden", true);
            }
        }
    }


    getVariantData() {
        this.variantData =
            this.variantData ||
            JSON.parse(this.querySelector('[type="application/json"]').textContent);
        return this.variantData;
    }
}

customElements.define("variant-selects", VariantSelects);

class BlogSection extends HTMLElement {
    constructor() {
        super();
        this.element = this;

        this.blogWrapper = this.element.querySelector("#BlogArticleWrapper");
        this.blogElement = this.element.querySelectorAll(".BlogArticle");

        if (window.theme.enableImageAnimations) {
            new RevolutionAnimation(this.element);
        }

        this.options = JSON.parse(this.element.getAttribute("data-settings"));
        if (this.options.layout == "masonary") {
            window.addEventListener("resize", this.setupGetInspredGrid.bind(this));
            document.addEventListener(
                "DOMContentLoaded",
                this.setupGetInspredGrid.bind(this)
            );
        }
    }

    setupGetInspredGrid() {
        const el = this.blogWrapper;
        if (el.lengtth == 0) {
            return;
        }

        var currentClientWidth = Math.max(
            document.body.offsetWidth,
            document.documentElement.offsetWidth,
            document.documentElement.clientWidth
        );

        const items = this.blogElement;
        const lastItem = items[items.length - 1];
        if (items.length == 0) {
            return;
        }

        const itemWidth = parseFloat(window.getComputedStyle(lastItem).width);

        let maxItemHeight = lastItem.offsetHeight;
        const numberOfCols = Math.floor(currentClientWidth / itemWidth);

        let isSmall = false;
        let rowTemp = 0;
        let maxHeight = 0;
        items.forEach((item, i) => {
            let rowHeiht = 0;

            const col = i % numberOfCols;
            const row = Math.floor(i / numberOfCols);

            /*calculate height of row, global max item height */
            if (row > 0) {
                for (let i = 1; i <= row; i++) {
                    const preParalelIndex = col + (i - 1) * numberOfCols;
                    const paralelEl = items[preParalelIndex];
                    rowHeiht = rowHeiht + paralelEl.offsetHeight;

                    maxItemHeight =
                        maxItemHeight < paralelEl.offsetHeight
                            ? paralelEl.offsetHeight
                            : maxItemHeight;
                }

                maxHeight = maxHeight < rowHeiht ? rowHeiht : maxHeight;
            }

            /* initialize is small flag for that row */
            if (row !== rowTemp) {
                rowTemp = row;

                isSmall = row % 2 != 0;
            }

            const left = col * itemWidth;

            const top = rowHeiht.toFixed(2);

            if (top !== "NaN") {
                const isHidden = false; //row > numberOfRows-2 && col%2 == 0; //hidden last two blog posts, overflow problem

                if (!isHidden) {
                    const padding = isSmall
                        ? `${90 + Math.random() * 20}%`
                        : `${110 + Math.random() * 40}%`;

                    item.querySelector(".BlogItem--Wrapper").style.paddingTop =
                        padding + "px";

                    const myitem = item;
                    myitem.style.cssText = "left:" + left + "px;top:" + top + "px";

                    isSmall = !isSmall;
                }
            }
        });

        var elHeight = parseInt(maxHeight) + parseInt(maxItemHeight);
        el.style.cssText =
            "width:" +
            numberOfCols * itemWidth +
            "px;height:" +
            elHeight +
            "px;margin:auto";
    }
}

customElements.define("blog-section", BlogSection);

class SearchBar extends HTMLElement {
    constructor() {
        super();
        this.element = this;
        this.searchElement = this;
        this.delegateElement = new Delegate(this.element);
        this.delegateBody = new Delegate(document.body);
        this.searchInputElement = this.element.querySelector('[name="q"]');
        this.queryMap = {};
        this.searchResultsElement = this.element.querySelector(".SearchInitial");
        this.pageOverlayElement = document.querySelector(".pageOverlay");
        this.options = JSON.parse(this.element.getAttribute("data-settings"));
        this.initialSearchLayout = this.searchResultsElement.cloneNode(true);
        if (window.theme.showRecentSearches) {
            this.getRecentSearches();
        }
        if (window.theme.showSuggestedSearches) {
            this.getSuggestedSearches();
        }
        this.carouselElement = this.element.querySelector(".SearchCollection");
        if (this.carouselElement) {
            if (new Responsive().matchesBreakpoint("desk")) {
                this.carousel = new RevolutionSwiper(this.carouselElement);
            }
        }

        document.documentElement.style.setProperty(
            "--search-header-height",
            `${this.searchInputElement.offsetHeight + 48}px`
        );

        if (window.theme.enableImageAnimations) {
            new RevolutionAnimation(this.element);
        }

        this.bindEvents();
    }

    bindEvents() {
        this._onInputListener = this.debounce(this.onInput.bind(this), 450);

        this.delegateElement.on(
            "click",
            '[data-action="open-search"]',
            this.openSearch.bind(this)
        );
        this.delegateElement.on(
            "click",
            '[data-action="close-search"]',
            this.closeSearch.bind(this)
        );

        this.searchInputElement.addEventListener("input", this._onInputListener);

        this.delegateElement.on(
            "click",
            '[data-action="search-string"]',
            this.onInput.bind(this)
        );

        this.delegateElement.on(
            "keypress",
            '[data-action="search-string"]',
            this.onInput.bind(this)
        );

        this.delegateElement.on(
            "click",
            '[data-action="clear-search"]',
            this.clearSearch.bind(this)
        );

        this.delegateBody.on("menu:open", this.closeSearch.bind(this));
        this.delegateBody.on("close:search", this.closeSearch.bind(this));
    }

    initCarousel(noResult) {
        if (
            new Responsive().matchesBreakpoint("desk") ||
            (!noResult && new Responsive().matchesBreakpoint("tablet-and-up"))
        ) {
            var carousel = this.searchResultsElement.querySelector(
                "[data-swiper-settings]"
            );
            if (carousel) {
                this.newCarousel = new RevolutionSwiper(carousel);
            }
            this.element.dispatchEvent(
                new CustomEvent("favorites:toggle", {bubbles: true})
            );
        }
    }

    debounce(fn, delay) {
        var _this0 = this;

        var timer = null;

        return function () {
            for (
                var _len = arguments.length, args = Array(_len), _key = 0;
                _key < _len;
                _key++
            ) {
                args[_key] = arguments[_key];
            }

            clearTimeout(timer);

            timer = setTimeout(function () {
                fn.apply(_this0, args);
            }, delay);
        };
    }

    clearSearch() {
        this.clearBtn = this.element.querySelector(".clearSeacrh");
        this.inputValue = this.element.querySelector(".SearchInput");

        this.inputValue.value = "";
        this.clearBtn.style.display = "none";

        this.resetSearch();
    }

    openSearch(event) {

        event.preventDefault();
        if (this.isOpen) {
            this.closeSearch();
            return;
        }
        this.element.dispatchEvent(
            new CustomEvent("menu:close", {bubbles: true})
        );
        var _this = this;
        var target = event.target;
        if (
            !this.searchElement.querySelector(".SearchSlide ") &&
            this.options["product"] &&
            this.options["collection"] == ""
        ) {
            this.loadRecommendations();
        }

        target.parentElement
            .querySelector(".SearchWrapper")
            .setAttribute("aria-hidden", false);
        this.pageOverlayElement.classList.add("is-visible");
        document.body.style.position = "fixed";
        document.body.style.width = "100%";
        this.closeListener = _this.closeSearch.bind(this);
        this.pageOverlayElement.addEventListener("click", _this.closeListener);
        bodyScrollLock.disableBodyScroll(
            this.searchElement.querySelector("[data-scrollable]"),
            bodyScrollLockOptions
        );
        this.isOpen = true;

        setTimeout(() => {
            _this.searchInputElement.focus();
        }, 200);

        document.body.querySelector("#shopify-section-header").style.zIndex = "99";

        if (this.options["transparent"]) {
            setTimeout(() => {
                document.body
                    .querySelector("#header")
                    .classList.remove("Header--Transparent");
            }, 15);
        }

    }

    closeSearch() {
        event.preventDefault();
        var _this = this;
        if (!this.isOpen) {
            return;
        }
        bodyScrollLock.enableBodyScroll(_this.searchElement, bodyScrollLockOptions);

        document.body.querySelectorAll(".SearchWrapper").forEach((item, i) => {
            item.setAttribute("aria-hidden", true);
        });
        _this.pageOverlayElement.classList.remove("is-visible");
        document.body.querySelector(
            "#shopify-section-header"
        ).style.backgroundColor = "transparent";
        document.body.style.position = "relative";
        document.body.style.width = "100%";
        if (_this.options["transparent"]) {
            document.body
                .querySelector("#header")
                .classList.add("Header--Transparent");
        }
        setTimeout(() => {
            document.body.querySelector("#shopify-section-header").style.zIndex = "9";
        }, 300);

        this.isOpen = false;
    }

    onInput(event) {
        this.clearBtn = this.element.querySelector(".clearSeacrh");

        this.lastInputValue = event.target.value;
        var passTrough = false;
        var _this = this;
        this.searchResultsElement.style.opacity = 0;
        if (event.target.getAttribute("data-value") && _this.lastInputValue === 0) {
            this.lastInputValue = event.target.getAttribute("data-value");
            const el = _this.searchElement.querySelector(".SearchInput");
            passTrough = true;
            el.setAttribute("value", _this.lastInputValue);
            el.value = _this.lastInputValue;
        } else {
            if (event.keyCode === 13) {
                return;
            }
            if (this.lastInputValue === "") {
                this.initialSearchLayout.style.opacity = 0;
                this.resetSearch();
                return;
            }
        }
        this.inputValue = this.element.querySelector(".SearchInput").value;
        if (this.inputValue == "") {
            this.clearBtn.style.display = "none";
        } else {
            this.clearBtn.style.display = "flex";
        }

        var queryOptions = {
            method: "GET",
            credentials: "same-origin",
        };
        if (_this.options["suggestedCollections"]) {
            const url = `${
                window.routes.localeRootUrl
            }/search/suggest.json?q=${encodeURIComponent(
                this.lastInputValue
            )}&resources[type]=collection&resources[limit]=1`;
            var queries = [fetch(url, queryOptions)];
        }

        if (window.theme.searchMode !== "product") {
            const url = `${
                window.routes.localeRootUrl
            }/search?view=ajax&q=${encodeURIComponent(
                this.lastInputValue
            )}&type=${window.theme.searchMode.replace("product,", "")}`;
            queries.push(fetch(url, queryOptions));
        }
        const url = `${
            window.routes.localeRootUrl
        }/search?view=ajax&q=${encodeURIComponent(
            this.lastInputValue
        )}&type=product`;
        queries.push(fetch(url, queryOptions));
        this.queryMap[this.lastInputValue] = true;

        Promise.all(queries).then(function (responses) {
            if (_this.lastInputValue !== event.target.value && passTrough == false) {
                return;
            }
            delete _this.queryMap[event.target.value];

            Promise.all(
                responses.map(function (response) {
                    return response.text();
                })
            ).then(function (contents) {
                //resultExists determines if there is any other results like products, articles or pages

                var resultExistsObject = [],
                    resultExists,
                    collectionHTML = document.createElement("div");

                contents.forEach((item, i) => {
                    if (item.includes("resources")) {
                        let collectionInner = "",
                            collectionObject = JSON.parse(item);
                        if (collectionObject.resources.results.collections.length > 0) {
                            collectionHTML.innerHTML = _this.layouts(
                                _this.lastInputValue,
                                false,
                                false,
                                "collectionLayout"
                            );
                            resultExistsObject.push(true);
                            collectionObject.resources.results.collections.forEach(function (
                                entry
                            ) {
                                collectionInner += _this.layouts(
                                    entry.url,
                                    entry.featured_image.url,
                                    entry.title,
                                    "collectionItem"
                                );
                            });
                            collectionHTML.querySelector(".Segment__Content").innerHTML =
                                collectionInner;
                        } else {
                            resultExistsObject.push(false);
                            collectionHTML.innerHTML = _this.layouts(
                                false,
                                false,
                                false,
                                "collectionItemNoResults"
                            );
                        }

                        contents[i] = collectionHTML.innerHTML;
                    } else {
                        if (item.includes("js-noresult")) {
                            resultExistsObject.push(false);
                        } else {
                            resultExistsObject.push(true);
                        }
                    }
                });

                if (resultExistsObject.includes(true)) {
                    resultExists = true;
                } else {
                    resultExists = false;
                }

                if (window.theme.showRecentSearches) {
                    _this.recentSearches();
                }

                _this.loadData(resultExists, contents);
            });
        });
    }

    loadData(resultExists, data) {
        switch (resultExists) {
            case true:
                let content = "";
                let tempContent = "";
                let block = document.createElement("div");
                data.forEach((item, i) => {
                    if (i < 2) {
                        block.innerHTML += item;
                    } else {
                        tempContent += item;
                    }
                });

                content =
                    `<div class="Collection--Article">${block.innerHTML}</div>` +
                    tempContent;

                this.searchResultsElement.innerHTML = `<div class="SearchLayout--2items">${content}</div>`;
                this.searchResultsElement.style.display = "flex";
                break;

            case false:
                let tempElement = document.createElement("div");
                tempElement.innerHTML = data[1];

                tempElement = tempElement
                    .querySelector("template")
                    .content.firstElementChild.cloneNode(true);

                if (this.options["noResultcollection"]) {
                    this.searchResultsElement.innerHTML = this.layouts(
                        tempElement.innerHTML,
                        false,
                        false,
                        "noResults"
                    );
                } else {
                    this.searchResultsElement.innerHTML = this.layouts(
                        tempElement.innerHTML,
                        false,
                        false,
                        "noResultsNoSuggestions"
                    );
                }
                this.searchResultsElement.style.display = "flex";
                break;
        }

        if (window.theme.enableImageAnimations) {
            new RevolutionAnimation(this.searchResultsElement);
        }
        this.searchResultsElement.setAttribute("aria-hidden", "false");
        this.initCarousel();
        this.element.dispatchEvent(
            new CustomEvent("favorites:toggle", {bubbles: true})
        );
        this.searchResultsElement.style.opacity = 1;
    }

    layouts(string1, string2, string3, type) {
        var template = "";
        switch (type) {
            case "collectionLayout":
                template = `<div class="SearchLayout__Section--collections">
          <div class="SearchSegmentHeader">
            <span class="u-s4">${window.languages.collections}</span>
          </div>
          <div class="Segment__Content">${string3}</div>
        </div>`;
                break;

            case "collectionItem":
                if (string2) {
                    template = `<a href="${string1}" class="CollectionSearchItem mt-l u-p4 SearchSlide" >
            <h5 class="u-p4 hoverColor">${string3}</h5>
        </a>`;
                } else {
                    template = `<a href="${string1}" class="CollectionSearchItem u-p4 SearchSlide" >
            <div class="SearchCollectionContent">
              <h5 class="u-p4 hoverColor">${string3}</h5>
            </div>
        </a>`;
                }

                break;

            case "collectionItemNoResults":
                template = `<div class="searchSegment">
          <div class="SearchSegmentHeader">
            <span class=" u-s4">${window.languages.collections}</span>
          </div>
          <div class="Segment__Content">
            <p class="SegmentNoResult u-p4">${window.languages.no_results}</p>
          </div>
        </div>`;
                break;

            case "noResults":
                template = `<div class="SearchLayout__Section Search--Recommendations-noResults">${string1}</div>\n`;
                break;

            case "noResultsNoSuggestions":
                template = `<div class="SearchLayout__Section Search--Recommendations-noResultsAll">${string1}</div>\n`;
                break;
        }

        return template;
    }

    loadRecommendations() {
        var _this = this,
            product_to_search = _this.options["product"],
            url =
                window.routes.localeRootUrl +
                "/recommendations/products?section_id=search_suggested&product_id=" +
                product_to_search +
                "&limit=8";

        return fetch(url).then(function (response) {
            return response.text().then(function (content) {
                var container = document.createElement("div");
                var contentjq = document.createElement("div");
                contentjq.innerHTML = content;
                container.innerHTML = contentjq.innerHTML;
                const newSwiper = _this.element.querySelector(
                    ".SearchInitial--Products"
                );
                newSwiper.innerHTML = container.querySelector(
                    ".ProductRecommendations"
                ).innerHTML;
                _this.initCarousel();
                if (window.theme.enableImageAnimations) {
                    new RevolutionAnimation(newSwiper);
                }
                new AddToCart(_this.element);
            });
        });
    }

    resetSearch() {
        let initialProducts = this.searchResultsElement.querySelector(
                ".SearchInitial--Products"
            ),
            initialLayout = this.initialSearchLayout.querySelector(
                ".SearchInitial--Recents"
            );

        this.searchResultsElement.classList.remove("SearchInitial--SecondView");
        this.searchResultsElement.style.display = "";

        if (initialLayout) {
            initialLayout.style.opacity = 0;
        }
        if (initialProducts) {
            initialProducts.style.opacity = 0;
        }

        this.searchResultsElement.innerHTML = this.initialSearchLayout.innerHTML;

        const el = this.searchElement.querySelector(".Search__Form");
        el.value = "";
        el.removeAttribute("value");
        this.searchElement.querySelector(".SearchInput").value = "";
        this.searchResultsElement.setAttribute("aria-hidden", "false");

        if (window.theme.showRecentSearches) {
            this.getRecentSearches();
        }
        if (window.theme.showSuggestedSearches) {
            this.getSuggestedSearches();
        }
        if (this.options["product"] && this.options["collection"] == "") {
            this.loadRecommendations();
        }
        if (window.theme.enableImageAnimations) {
            new RevolutionAnimation(this.element);
        }

        initialLayout = this.element.querySelector(".SearchInitial--Recents");
        if (initialLayout) {
            initialLayout.style.opacity = 1;
        }
        if (initialProducts) {
            initialProducts.style.opacity = 1;
        }

        this.initCarousel();
        this.searchResultsElement.style.opacity = 1;
    }

    recentSearches() {
        this.searchResultsElement.style.opacity = 0;

        if (this.lastInputValue === "") {
            this.initialSearchLayout.style.opacity = 0;
            this.resetSearch();
            return;
        }

        if (this.lastInputValue.length > 3) {
            var searchTerm = JSON.parse(localStorage.getItem("searchTerms") || "[]");
            if (!searchTerm.includes(this.lastInputValue)) {
                searchTerm.unshift(this.lastInputValue);
            }

            // Then, we save the search info into the local storage, by keeping only the 5 most recent
            try {
                localStorage.setItem(
                    "searchTerms",
                    JSON.stringify(searchTerm.slice(0, 5))
                );
            } catch (error) {
            }
        }
    }

    getRecentSearches() {
        var appendString = "";
        var items = JSON.parse(localStorage.getItem("searchTerms") || "[]");
        var appElement = this.searchElement.querySelector(
            ".Search--Recent__results"
        );
        if (items.length > 0) {
            items.forEach((id, index) => {
                appendString =
                    appendString +
                    "<li tabIndex='0' class='u-p5' data-action='search-string' data-value='" +
                    id +
                    "'>" +
                    id +
                    "</li>";
            });

            appElement.innerHTML = appendString;
        } else {
            var appEl = this.searchElement.querySelector(".Search--Recent");
            appEl.style.display = "none";
        }
    }

    getSuggestedSearches() {
        var appendString = "";
        const arr = this.options.items;

        if (arr.length == 0) {
            return;
        }
        arr.sort(function () {
            return 0.5 - Math.random();
        });
        var filtred = arr.filter(function (a) {
            if (!a.includes("_")) {
                return a;
            }
        });

        var i;
        appendString = "";
        for (i = 0; i < 5; i++) {
            if (filtred[i]) {
                var filteredResult = filtred[i].replace(":", " ");
                filteredResult = filteredResult.replace("-", " ");
                appendString =
                    appendString +
                    "<li tabindex='0' class='u-p5' data-action='search-string' data-value='" +
                    filteredResult +
                    "'>" +
                    filteredResult +
                    "</li>";
            }
        }
        var appElement = this.searchElement.querySelector(
            ".Search--Suggested__results"
        );
        appElement.innerHTML = appendString;
    }
}

customElements.define("search-bar", SearchBar);

class ContactSection extends HTMLElement {
    constructor() {
        super();
        this.element = this;
        this.delegateElement = new Delegate(this.element);
        this.bindEvents();
        this.toggleButton();
    }

    bindEvents() {
        this.delegateElement.on(
            "change",
            "[data-state='required']",
            this.toggleButton.bind(this)
        );
    }

    toggleButton() {
        this.buttonState = true;

        var allBoxes = this.element.querySelectorAll("[data-state='required']");
        allBoxes.forEach((item, i) => {
            if (item.checked == false) {
                this.buttonState = false;
            }
        });
        if (this.buttonState == true) {
            this.element.querySelector(".Contact-Btn").removeAttribute("disabled");
        } else {
            this.element.querySelector(".Contact-Btn").setAttribute("disabled", true);
        }
    }
}

customElements.define("contact-section", ContactSection);

class LocalizationForm extends HTMLElement {
    constructor() {
        super();
        this.elements = {
            input: this.querySelector(
                'input[name="language_code"], input[name="country_code"]'
            ),
        };
        this.querySelectorAll("a").forEach((item) =>
            item.addEventListener("click", this.onItemClick.bind(this))
        );
    }

    onItemClick(event) {
        event.preventDefault();
        const form = this.querySelector("form");
        this.elements.input.value = event.currentTarget.dataset.value;
        if (form) form.submit();
    }
}

customElements.define("localization-form", LocalizationForm);

class PickupAvailability extends HTMLElement {
    constructor() {
        super();
        this.element = this;
        if (!this.hasAttribute("available")) return;
        this.fetchAvailability(this.dataset.variantId);
    }

    fetchAvailability(variantId) {
        const variantSectionUrl = `${window.routes.localeRootUrl}/variants/${variantId}/?section_id=pickup`;

        fetch(variantSectionUrl)
            .then((response) => response.text())
            .then((text) => {
                const sectionInnerHTML = new DOMParser()
                    .parseFromString(text, "text/html")
                    .querySelector(".shopify-section");
                this.renderPreview(sectionInnerHTML);
            })
            .catch((e) => {
                this.renderError();
            });
    }

    renderError() {
    }

    renderPreview(sectionInnerHTML) {
        this.element.innerHTML = "";

        this.element.appendChild(
            sectionInnerHTML.querySelector(".LocalPickup__Wrapper")
        );
        if (sectionInnerHTML.querySelector("#LocalPickup")) {
            this.element.appendChild(sectionInnerHTML.querySelector("#LocalPickup"));
            new Drawer(this.element.querySelector("#LocalPickup"));
        }
    }
}

customElements.define("pickup-availability", PickupAvailability);

class CartNote extends HTMLElement {
    constructor() {
        super();
        this.element = this;
        this.delegateElement = new Delegate(this.element);
        this.textarea = this.element.querySelector("textarea");
        this.button = this.element.querySelector(".CartNote--Submit");
        this.noteSucess = this.element.querySelector(".cartNote--Success");
        this.bindEvents();
    }

    bindEvents() {
        this.delegateElement.on(
            "click",
            "[data-action='update-note']",
            this.updateNote.bind(this)
        );

        this.delegateElement.on(
            "click",
            "[data-action='edit-note']",
            this.editNote.bind(this)
        );
    }

    editNote() {
        this.textarea.removeAttribute("disabled");
        this.button.innerText = window.cartStrings.enter_note;
        this.button.setAttribute("data-action", "update-note");
        this.textarea.focus();
        this.noteSucess.style.visibility = "hidden";
        this.noteSucess.style.opacity = "0";
    }

    updateNote() {
        var _this = this;
        this.value = this.textarea.value;

        fetch(window.routes.localeRootUrl + "/cart/update.js", {
            body: JSON.stringify({note: this.value}),
            credentials: "same-origin",
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "X-Requested-With": "XMLHttpRequest",
            },
        }).then(function (response) {
            if (response.ok) {
                if (_this.value == "") {
                    return;
                }
                _this.textarea.setAttribute("disabled", "disabled");
                _this.button.innerText = window.cartStrings.note_change;
                _this.button.setAttribute("data-action", "edit-note");
                _this.noteSucess.style.visibility = "visible";
                _this.noteSucess.style.opacity = "1";
            }
        });
    }
}

customElements.define("cart-note", CartNote);

class AnimationWrapper extends HTMLElement {
    constructor() {
        super();
        this.element = this;
        if (window.theme.enableImageAnimations) {
            new RevolutionAnimation(this.element);
        }
    }
}

customElements.define("animation-wrapper", AnimationWrapper);

class VJSDatepicker {
    constructor(element) {
        this.element = element;
        this.build(this.element);
    }

    build(element) {
        // creates today's date in dd/mm/yyyy format
        const now = new Date(Date.now()).toLocaleDateString();

        this.datepicker = new Datepicker(element, {
            autohide: true,
            startView: 2,
            maxDate: now,
            format: "dd.mm.yyyy",
        });
    }

    show() {
        this.datepicker.show();
    }

    toggle() {
        this.datepicker.toggle();
    }

    hide() {
        this.datepicker.hide();
    }
}

class NewsletterPopup extends HTMLElement {
    constructor() {
        super();
        this.element = this;
        this.datepickerElement = this.element.querySelector(
            "#RegisterForm-birthday"
        );
        if (this.datepickerElement) {
            this.datepicker = new VJSDatepicker(this.datepickerElement);
        }

        this.delegateElement = new Delegate(this.element);
        this.pageOverlayElement = document.querySelector(".pageOverlay");
        this.options = JSON.parse(
            this.element.getAttribute("data-section-settings")
        );
        this.handleOpenOptions();
        if (this.options.edit_mode == true) {
            this.options.delay = 0;
            this.openNewsletter();
        }

        this.calendarOnClickHandler();
    }

    handleOpenOptions() {
        let sessionKey = sessionStorage.getItem("popup-seen");
        var localKey = localStorage.getItem("popup-seen");
        if (this.options.show_only_once == true && localKey == "true") {
            return;
        }
        if (sessionKey != "true") {
            if (this.options.scroll_amount > 0) {
                this.scrollListener = this.scrollListener.bind(this);
                document.addEventListener("scroll", this.scrollListener);
            } else {
                this.openNewsletter();
            }
        }
    }

    scrollListener() {
        var _this = this,
            body = document.body,
            html = document.documentElement;
        let docHeight = Math.max(
            body.scrollHeight,
            body.offsetHeight,
            html.clientHeight,
            html.scrollHeight,
            html.offsetHeight
        );
        let percScrolled = (window.scrollY / docHeight) * 100;
        if (percScrolled >= _this.options.scroll_amount) {
            _this.openNewsletter();
        }
    }

    openNewsletter() {
        var _this = this;
        setTimeout(() => {
            this.element.setAttribute("aria-hidden", false);
            this.pageOverlayElement.classList.add("is-visible");
            bodyScrollLock.disableBodyScroll(this.element, bodyScrollLockOptions);
            this.onClickOutsideListener = this.closeNewsletter.bind(this);
            this.pageOverlayElement.addEventListener(
                "click",
                this.onClickOutsideListener
            );
            sessionStorage.setItem("popup-seen", true);
            localStorage.setItem("popup-seen", true);
            this.delegateElement.on(
                "click",
                '[data-action="close-modal"]',
                this.closeNewsletter.bind(this)
            );
        }, 1000 * _this.options.delay);
    }

    closeNewsletter() {
        this.element.setAttribute("aria-hidden", true);
        this.pageOverlayElement.classList.remove("is-visible");
        bodyScrollLock.clearAllBodyScrollLocks();
        this.pageOverlayElement.removeEventListener(
            "click",
            this.onClickOutsideListener
        );
        document.removeEventListener("scroll", this.scrollListener);
    }

    calendarOnClickHandler() {
        this.delegateElement.on("click", ".Newsletter--BirthDate", () =>
            this.showCalendar()
        );
    }

    showCalendar() {
        this.datepicker.show();
    }
}

customElements.define("newsletter-popup", NewsletterPopup);

class FormShowBlog extends HTMLElement {
    constructor() {
        super();
        this.element = this;
        this.delegateElement = new Delegate(this.element);
        this.formBlog = this.element.querySelector(".comments--form");
        this.successMessage = this.element.querySelector(".successMessage");
        this.bindEvents();
        this.handleAfterState();
    }

    bindEvents() {
        this.delegateElement.on(
            "click",
            '[data-action="handle-hidden"]',
            this.toggleEffect.bind(this)
        );
        this.delegateElement.on(
            "click",
            '[data-action="load-more"]',
            this.loadMore.bind(this)
        );
        this.delegateElement.on(
            "click",
            '[data-action="copy"]',
            this.copy.bind(this)
        );
    }

    copy() {
        var url = document.querySelector("#currentUrl");
        url.value = window.location.href;

        this.successMessage.classList.remove("hidden");
        setTimeout(() => {
            this.successMessage.classList.add("hidden");
        }, 1000);

        navigator.clipboard.writeText(url.value);
    }

    handleAfterState() {
        if (window.location.href.indexOf("#comment_form") > -1) {
            this.element
                .querySelector(".comments--buttonWrite")
                .setAttribute("aria-hidden", "true");
            this.formBlog.classList.remove("comments--formHide");
        }
    }

    toggleEffect(event, target) {
        target.setAttribute("aria-hidden", "true");
        this.formBlog.classList.remove("comments--formHide");
    }

    loadMore(event, target) {
        const _this = this;
        let dataHref = target.getAttribute("data-href");

        return fetch(window.routes.localeRootUrl + dataHref, {
            credentials: "same-origin",
            method: "GET",
        }).then(function (content) {
            content.text().then(function (htmlData) {
                let html = new DOMParser().parseFromString(htmlData, "text/html");
                let newComments = html.querySelectorAll(".ArticleComments--Comment");

                let curDocument = _this.element.querySelector(".ArticleComments");
                curDocument.append(...newComments);
                let dataHref = html.querySelector(".comments--buttonFooter");

                if (dataHref) {
                    dataHref = dataHref.dataset.href;
                    _this.element.querySelector(".comments--buttonFooter").dataset.href =
                        dataHref;
                } else {
                    _this.element.querySelector(".comments--buttonFooter").remove();
                }
            });
        });
    }
}

customElements.define("main-article", FormShowBlog);

class productReviews extends HTMLElement {
    constructor() {
        super();
        this.element = this;
        this.domDelegate = new Delegate(this.element);
        this.delegateElement = new Delegate(this.element);

        this.bindEvents();
        this.addValueToTitle();
    }

    bindEvents() {
        this.domDelegate.on(
            "click",
            ".spr-summary-actions-newreview",
            this.handleReview.bind(this)
        );
    }

    handleReview(event) {
        event.target.classList.add("hidden");
        this.addValueToTitle();
    }

    addValueToTitle() {
        var titleInput = this.element.querySelector(
            '.spr-form-input.spr-form-input-text[name="review[title]"]'
        );
        if (titleInput) {
            titleInput.type = "hidden";
            titleInput.value = "Title";
        }
    }
}

customElements.define("product-reviews", productReviews);

class sectionTabs extends HTMLElement {
    constructor() {
        super();
        this.element = this;
        this.newSpec = this.element.parentElement;
        this.delegateElement = new Delegate(this.element);
        this.specBtn = this.element.querySelector("#spec-title");
        this.bindEvents();
    }

    bindEvents() {
        this.delegateElement.on(
            "click",
            '[data-action="toggle-specification"]',
            this.showSpecification.bind(this)
        );
        this.delegateElement.on(
            "click",
            '[data-action="toggle-formulas"]',
            this.showFormulas.bind(this)
        );
    }

    showFormulas(event, target) {
        const id = target.getAttribute("data-id");
        this.element.querySelectorAll(".specification-data").forEach((item) => {
            item.classList.add("hidden");
        });
        const formulas = this.element.querySelectorAll(`[data-open="${id}"]`);
        formulas.forEach((item) => {
            item.classList.remove("hidden");
        });

        this.element.querySelectorAll("#spec-title").forEach((item, i) => {
            item.classList.remove("active");
        });
        target.classList.add("active");
    }

    showSpecification(event, target) {
        const id = target.getAttribute("data-id");
        this.element.querySelectorAll(".specification-data").forEach((item, i) => {
            item.classList.add("hidden");
        });

        this.element.querySelector("#" + id).classList.remove("hidden");

        this.element.querySelectorAll("#spec-title").forEach((item, i) => {
            item.classList.remove("active");
        });
        target.classList.add("active");
    }
}

customElements.define("section-tabs", sectionTabs);

class Quote extends HTMLElement {
    constructor() {
        super();
        this.element = this;
        this.carouselElement = this.element.querySelector(".swiper");
        this.carousel = new RevolutionSwiper(this.carouselElement);
        if (window.theme.enableImageAnimations) {
            new RevolutionAnimation(this.element);
        }
    }
}

customElements.define("badagoom-quote", Quote);

class Ingredients extends HTMLElement {
    constructor() {
        super();
        this.element = this;
        this.delegateElement = new Delegate(this.element);
        this.carouselElement = this.element.querySelector(".swiper");
        this.carousel = new RevolutionSwiper(this.carouselElement);
        if (window.theme.enableImageAnimations) {
            new RevolutionAnimation(this.element);
        }

        this.pageOverlayElement = this.querySelector(".pageOverlay");
        this.onButtonPress();
        this.assignClickListener();
        this.checkForHiddenIngredients();

    }

    // BUTTON

    onButtonPress() {
        this.delegateElement.on(
            "click",
            ".ingredients__Button",
            this.loadMore.bind(this.element)
        );
    }

    loadMore(e) {
        e.preventDefault();

        for (let i = 0; i < 4; i++) {
            const cardElement = this.querySelector(
                '.ingredients__Card[aria-hidden="true"]'
            );

            if (cardElement) {
                this.showElement(cardElement);
            }
        }

        this.checkForHiddenIngredients();
    }

    showElement(cardElement) {
        cardElement.setAttribute("aria-hidden", "false");
    }

    checkForHiddenIngredients() {
        if (!this.querySelector('.ingredients__Card[aria-hidden="true"]') && this.querySelector(".ingredients__Button")) {
            this.querySelector(".ingredients__Button").classList.add("hide");
        }
    }

    // POPUP

    assignClickListener() {
        this.delegateElement.on("click", ".ingredients__Card", (clickedElement) => {
            this.showPopup(clickedElement);
        });
        this.delegateElement.on(
            "click",
            ".ingredients__ClosePopup",
            this.hidePopup.bind(this)
        );


        // this.delegateElement.on('click','.ingredients__Swiper', this.hidePopup.bind(this));
    }

    showPopup(clickedElement) {
        const popup = this.querySelector(".ingredients__Popup");
        const card = clickedElement.target.closest(".ingredients__Card");

        if (popup) {
            popup.setAttribute("aria-hidden", "false");
        }

        this.goToSlide(card);
        this.setOverlayVisibility(true);
        var focus = this.element.querySelector("[data-scrollable]");
        bodyScrollLock.disableBodyScroll(focus, bodyScrollLockOptions);
    }

    hidePopup() {
        const popup = this.querySelector(".ingredients__Popup");

        if (event.target.classList.contains('swiper-slide')) {
            return;
        }
        if (popup) {
            popup.setAttribute("aria-hidden", "true");
        }

        this.setOverlayVisibility(false);
        bodyScrollLock.clearAllBodyScrollLocks();
    }

    setOverlayVisibility(visibility) {
        this.hidePopupListener = this.hidePopup.bind(this);

        if (this.pageOverlayElement) {
            if (visibility) {
                this.pageOverlayElement.classList.add("is-visible");
                this.pageOverlayElement.addEventListener(
                    "click",
                    this.hidePopupListener
                );
            } else {
                this.pageOverlayElement.classList.remove("is-visible");
                this.pageOverlayElement.removeEventListener(
                    'click', this.hidePopupListener
                );
            }
        }
    }

    goToSlide(card) {
        const slide = card.getAttribute("swiper-slide");

        this.carousel.selectCell(slide);
    }
}

customElements.define("badagoom-ingredients", Ingredients);

class BadagoomInstagram extends HTMLElement {
    constructor() {
        super();
        this.element = this;
        var images = new Array();
        var boxes = new Array();
        this.carouselElement = this.element.querySelector(".swiper");
        this.carousel = new RevolutionSwiper(this.carouselElement);
        this.delegateElement = new Delegate(this.element);
        if (window.theme.enableImageAnimations) {
            new RevolutionAnimation(this.element);
        }
        var _this = this;
        var observer = new MutationObserver(function (mutations) {
            if (_this.element.querySelector(".instafeed-container")) {
                var allElements = _this.element.querySelectorAll(
                    ".instafeed-container"
                );
                allElements.forEach((item, i) => {
                    const img = item.querySelector("img");
                    if (img) {
                        images.push(img.getAttribute("data-src"));
                    }
                });
                observer.disconnect();
                _this.element
                    .querySelectorAll(".InstagramImageWrapper")
                    .forEach((item, i) => {
                        item.querySelector("img").setAttribute("data-src", images[i]);
                        item.querySelector("img").setAttribute("src", images[i]);
                    });
                setTimeout(
                    (document.querySelector("#insta-feed").style.display = "none"),
                    50
                );
            }
        });
        observer.observe(document, {
            attributes: false,
            childList: true,
            characterData: false,
            subtree: true,
        });
    }

    cleanSelector(selector) {
        (selector.match(/(#[0-9][^\s:,]*)/g) || []).forEach(function (n) {
            selector = selector.replace(n, '[id="' + n.replace("#", "") + '"]');
        });
        return selector;
    }
}

customElements.define("badagoom-instagram", BadagoomInstagram);

class NewSwiper extends HTMLElement {
    constructor() {
        super();
        this.element = this;
        if (
            window.theme.enableImageAnimations ||
            window.theme.enableTextAnimations
        ) {
            new RevolutionAnimation(this.element);
        }
        this.carouselElement = this.element.querySelector(".swiper");
        this.carousel = new RevolutionSwiper(this.carouselElement);
    }
}

customElements.define("swiper-section", NewSwiper);

class CollectionShowcase extends HTMLElement {
    constructor() {
        super();
        this.element = this;
        this.carouselElement = this.element.querySelector(".swiper");
        this.carousel = new RevolutionSwiper(this.carouselElement);
        this.changeSlide();
        if (window.theme.enableImageAnimations) {
            new RevolutionAnimation(this.element);
        }
    }
    changeSlide(){
        const menuItems = this.element.querySelectorAll('.collectionShowcase_MenuItem');
        menuItems.forEach((mi)  => {
            mi.addEventListener('click', () => {
                const index = mi.getAttribute('data-slide');
                this.slideTo(index);
                this.clearActive();
                mi.classList.add('active')
            })
        })
    }
    clearActive(){
        const menuItems = this.element.querySelectorAll('.collectionShowcase_MenuItem');
        menuItems.forEach((mi)  => {
            mi.classList.remove('active')
        })
    }
    slideTo(index){
        this.carousel.selectCell(index)
    }
}

customElements.define("collection-showcase", CollectionShowcase);

class BlogShowcase extends HTMLElement {
    constructor() {
        super();
        this.element = this;
        this.carouselElement = this.element.querySelector(".swiper");
        this.carousel = new RevolutionSwiper(this.carouselElement);
        if (window.theme.enableImageAnimations) {
            new RevolutionAnimation(this.element);
        }
    }
}

customElements.define("blog-showcase", BlogShowcase);

class LocalizationSelectors extends HTMLElement {
    constructor() {
        super();
        this.element = this;
        this.delegateElement = new Delegate(this.element);
        let responsive = new Responsive();
        let breakpoint = responsive.getCurrentBreakpoint();
        var selectBoxes = this.element.querySelectorAll(".RevolutionDropdown");
        var location = this.element.getAttribute("data-settings");
        this.delegateElement.on(
            "change",
            '[data-action="country-change"]',
            this.submitForm.bind(this)
        );
        if (location == "sidebarMenu") {
            var additionalOverlay = true;
        } else {
            var additionalOverlay = false;
        }
        if (breakpoint != "phone" && breakpoint != "tablet") {
            if (selectBoxes.length > 0) {
                selectBoxes.forEach((item, i) => {
                    new RevolutionSelectbox(item);
                });
            }
        } else {
            if (selectBoxes.length > 0) {
                selectBoxes.forEach((item, i) => {
                    new RevolutionSelectbox(item, true, additionalOverlay);
                });
            }
        }
    }

    submitForm() {
        event.target.closest("form").submit();
    }
}

customElements.define("localization-selectors", LocalizationSelectors);

class Search extends HTMLElement {
    constructor() {
        super();
        this.element = this;
        this.delegateElement = new Delegate(this.element);

        this.result = this.element.querySelectorAll(".Search--Result");

        this.openProductBtn = this.element.querySelector("#productBtn");
        this.openArticleBtn = this.element.querySelector("#articleBtn");

        this.bindEvents();

        /* get number of products & articles */
        var productNumber = this.element.querySelectorAll(".cardWrapper").length;

        var itemNumber = this.element.querySelector(".itemNumber");

        itemNumber.innerHTML = productNumber;

        var articleNumber =
            this.element.querySelectorAll(".article-wrapper").length;
        var itemNumber_2 = this.element.querySelector(".itemNumber_2");
        itemNumber_2.innerHTML = articleNumber;
        this.showProducts();
    }

    bindEvents() {
        this.delegateElement.on(
            "click",
            '[data-action="toggle-products"]',
            this.showProducts.bind(this)
        );
        this.delegateElement.on(
            "click",
            '[data-action="toggle-articles"]',
            this.showArticles.bind(this)
        );
    }

    showProducts() {
        this.getProducts = this.element.querySelectorAll(".SearchProductWrapper");
        this.hideArticles = this.element.querySelectorAll(".article-wrapper");

        this.hideArticles.forEach(function (article) {
            article.classList.add("hidden");
        });
        this.getProducts.forEach(function (product) {
            product.classList.remove("hidden");
        });
        this.openProductBtn.classList.add("active");
        this.openArticleBtn.classList.remove("active");
    }

    showArticles() {
        this.getArticles = this.element.querySelectorAll(".article-wrapper");
        this.hideProducts = this.element.querySelectorAll(".SearchProductWrapper");
        this.hideProducts.forEach(function (product) {
            product.classList.add("hidden");
        });
        this.getArticles.forEach(function (article) {
            article.classList.remove("hidden");
        });
        this.openProductBtn.classList.remove("active");
        this.openArticleBtn.classList.add("active");
    }
}

customElements.define("search-component", Search);

class ConnectedProducts extends HTMLElement {
    constructor() {
        super();
        this.element = this;
        this.carouselElement = this.element.querySelector(".swiper");
        this.carousel = new RevolutionSwiper(this.carouselElement);
        if (window.theme.enableImageAnimations) {
            new RevolutionAnimation(this.element);
        }
    }
}

customElements.define("connected-products", ConnectedProducts);

class AgeVerification extends HTMLElement {
    constructor() {
        super();
        this.element = this;
        this.delegateElement = new Delegate(this.element);

        this.inputDate = this.element.querySelector(".customerAge");

        this.datepicker();
        const checkAge = this.checkCustomerAge();

        if (!this.element.querySelector(".ageVerification-wrapper")) {
            checkAge = false;
        }

        const checkBirthday = this.checkBirthday();

        if (checkAge == false && checkBirthday == false) {
            this.bindEvents();
        }
    }

    checkBirthday() {
        if (localStorage.getItem("birthday")) {
            if (document.querySelector(".cartCheckout--Button")) {
                document
                    .querySelector(".cartCheckout--Button")
                    .removeAttribute("disabled", true);

                document
                    .querySelector(".ageVerification-wrapper")
                    .classList.add("hidden");
                this.element.dispatchEvent(
                    new CustomEvent("dob:removed", {bubbles: true})
                );
                return true;
            }
        }
    }

    bindEvents() {
        this.inputDate.addEventListener("keyup", this.checkAge.bind(this));
        this.inputDate.addEventListener("keydown", this.preventInput.bind(this));
    }

    datepicker() {
        const _this = this;
        const elem = this.element.querySelector("#customerAge");
        const datepicker = new Datepicker(elem, {
            autohide: true,
            startView: 2,
            maxDate: "12/31/2006",
            format: "dd.mm.yyyy",
        });

        elem.addEventListener("hide", function (e) {
            _this.checkAge();
        });
    }

    checkCustomerAge() {
        var customer = this.element.querySelector(".customerTag");
        if (!customer) {
            return false;
        }
        var customerTag = customer.value;
        var pattern = /(\d{2})\.(\d{2})\.(\d{4})/;
        var myBd = new Date(customerTag.replace(pattern, "$3-$2-$1"));

        var currentTime = new Date();
        const diffTime1 = Math.abs(currentTime - myBd);
        const diffDays1 = Math.ceil(diffTime1 / (1000 * 60 * 60 * 24));

        const myYears = Math.floor(diffDays1 / 365);

        if (myYears > 18) {
            document
                .querySelector(".cartCheckout--Button")
                .removeAttribute("disabled", true);
            document
                .querySelector(".ageVerification-wrapper")
                .classList.add("hidden");
            this.element.dispatchEvent(
                new CustomEvent("dob:removed", {bubbles: true})
            );
            return true;
        } else {
            return false;
        }
    }

    checkAge() {
        /* ADD DOTS */
        var dateBox = this.element.querySelector(".customerAge"),
            chars = dateBox.value.length,
            text = dateBox.value,
            key = event.keyCode || event.charCode;

        if (key == 8 || key == 46) {
        } else {
            if (chars == 2) {
                dateBox.value = text + ".";
            }
            if (chars == 5) {
                dateBox.value = text + ".";
            }
        }

        if (text == "NaN" || chars < 10) {
            this.element
                .querySelector(".cartCheckout--Button")
                .setAttribute("disabled", true);
            return;
        }

        /* CHECK AGE */
        var customerAge = this.element.querySelector(".customerAge").value;

        var currentTime = new Date();
        var d = new Date(
            customerAge.replace(/(\d{2}).(\d{2}).(\d{4})/, "$2/$1/$3")
        );

        const diffTime = currentTime - d;

        if (diffTime < 0 || !diffTime) {
            return;
        }
        const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

        const myYear = Math.floor(diffDays / 365);

        if (myYear < 18) {
            this.element
                .querySelector(".cartCheckout--Button")
                .setAttribute("disabled", true);
        } else {
            this.element
                .querySelector(".cartCheckout--Button")
                .removeAttribute("disabled", true);
            this.element.querySelector(".cartCheckout--Button").focus();
            localStorage.setItem("birthday", true);
        }
    }
}

customElements.define("age-verification", AgeVerification);

class FeaturedProduct extends HTMLElement {
    constructor() {
        super();
        this.element = this;
        this.delegateElement = new Delegate(this.element);
        this.delegateBody = new Delegate(this.element);
        this.carousel = [];
        this.carouselElement = this.element.querySelectorAll(".swiper");
        this.carouselElement.forEach((item, i) => {
            this.carousel[i] = new RevolutionSwiper(item);
        });
        new AddToCart(this.element);
        this.bindEvents();
    }

    bindEvents() {
        this.delegateElement.on(
            "click",
            "[data-action='toggle-featured']",
            this.toggleFeatured.bind(this)
        );
        this.delegateElement.on(
            "click",
            "[data-action='toggle-subscription']",
            this.resizeSwiper.bind(this)
        );
        this.delegateBody.on("resize:swiper", this.resizeSwiper.bind(this));
    }

    resizeSwiper() {
        setTimeout(() => {
            this.carousel.forEach((item) => {
                item.resize();
            });
        }, 310);
    }

    toggleFeatured(event, target) {
        const id = target.dataset.id;

        this.element
            .querySelector('.featuredProduct--Tab[aria-selected="true"]')
            .setAttribute("aria-selected", "false");
        this.element
            .querySelector('.featuredProduct--SwiperTab[aria-expanded="true"]')
            .setAttribute("aria-expanded", "false");
        target.setAttribute("aria-selected", "true");
        this.element.querySelector(`#${id}`).setAttribute("aria-expanded", "true");
    }
}

customElements.define("featured-product", FeaturedProduct);

class FAQSection extends HTMLElement {
    constructor() {
        super();
        let foundOne = false;
        const none = document.getElementById("none");
        const noneTerms = this.querySelector(".noTerms");
        this.clearBtn = this.querySelector(".clearSeacrh");
        this.delegateElement = new Delegate(this);
        const searchInput = document.querySelector('input[rel="searchbox"]');
        this.data = document.querySelectorAll(".Faq-Section");
        this.show(false);
        const _this = this;
        searchInput.addEventListener("input", function (event) {
            // reset state
            _this.show(false);
            foundOne = false;
            _this.clearBtn.style.display = "none";
            const input = event.target;
            if (input.value) {
                _this.clearBtn.style.display = "flex";
                const toMatch = input.value.toLowerCase();

                for (let i = 0, len = _this.data.length; i < len; i++) {
                    const match = _this.data[i].innerHTML.toLowerCase().includes(toMatch);
                    _this.data[i].style.display = match ? "flex" : "none";
                    if (match) foundOne = true;
                }
                if (!foundOne) {
                    _this.show(true);
                    noneTerms.innerHTML = input.value;
                }
            } else _this.resetState();
        });

        this.delegateElement.on(
            "click",
            '[data-action="clear-search"]',
            this.resetState.bind(this)
        );
    }

    faqSearch() {
        let faqs = document.querySelectorAll(".Faq-section_content");
        let search_query = document.getElementById("searchbox").value;
        for (var i = 0; i < faqs.length; i++) {
            if (
                faqs[i].textContent.toLowerCase().includes(search_query.toLowerCase())
            ) {
                faqs[i].classList.remove("is-hidden");
            } else {
                faqs[i].classList.add("is-hidden");
            }
        }
    }

    resetState() {
        for (let i = 0, len = this.data.length; i < len; i++) {
            this.data[i].style.display = "flex";
        }

        this.show(false);
        this.inputValue = this.querySelector("#searchbox");

        this.inputValue.value = "";
        this.clearBtn.style.display = "none";
    }

    show(bool) {
        none.style.display = bool ? "flex" : "none";
    }
}

customElements.define("faq-section", FAQSection);

class AllIngredients extends HTMLElement {
    constructor() {
        super();
        this.element = this;
        this.delegateElement = new Delegate(this.element);

        this.onButtonPress();
        this.assignClickListener();
        this.checkForHiddenIngredients();

    }

    // BUTTON

    onButtonPress() {
        this.delegateElement.on(
            "click",
            ".ingredients__Button",
            this.loadMore.bind(this.element)
        );
    }

    loadMore(e) {
        e.preventDefault();

        for (let i = 0; i < 4; i++) {
            const cardElement = this.querySelector(
                '.ingredients__Card[aria-hidden="true"]'
            );

            if (cardElement) {
                this.showElement(cardElement);
            }
        }

        this.checkForHiddenIngredients();
    }

    showElement(cardElement) {
        cardElement.setAttribute("aria-hidden", "false");
    }

    checkForHiddenIngredients() {
        if (!this.querySelector('.ingredients__Card[aria-hidden="true"]') && this.querySelector(".ingredients__Button")) {
            this.querySelector(".ingredients__Button").classList.add("hide");
        }
    }

}

customElements.define("badagoom-all_ingredients", AllIngredients);
